
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("89CKS", function(module, exports) {
/**
 * @generated SignedSource<<29d02a00238e986613f78bcab9812352>>
 * @relayHash 1c39b72e16854d19d11c51ceef0122b1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 57a186e10000ef184bec3a0e71a8dec9c1b57a66702d145178c98368d5d78434
const $76fac522acc3b282$var$node = function() {
    var v0 = [
        {
            "concreteType": "Entitlements",
            "kind": "LinkedField",
            "name": "entitlements",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ExternalCollaboratorFeature",
                    "kind": "LinkedField",
                    "name": "externalCollaborator",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isEntitled"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "fetchMentionsProviderDataQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "fetchMentionsProviderDataQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "1c39b72e16854d19d11c51ceef0122b1",
            "id": "57a186e10000ef184bec3a0e71a8dec9c1b57a66702d145178c98368d5d78434",
            "metadata": {},
            "name": "fetchMentionsProviderDataQuery",
            "operationKind": "query",
            "text": "query fetchMentionsProviderDataQuery{entitlements{externalCollaborator{isEntitled}}}"
        }
    };
}();
$76fac522acc3b282$var$node.hash = "97f5ab279ca8162d7d39b760a9aa8808";
var $76fac522acc3b282$export$2e2bcd8739ae039 = $76fac522acc3b282$var$node;
module.exports["default"] = $76fac522acc3b282$export$2e2bcd8739ae039;

});

parcelRegister("9cGsb", function(module, exports) {
"use strict";
var $6b362a72760d8152$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
function $6b362a72760d8152$var$__export(m) {
    for(var p in m)if (!module.exports.hasOwnProperty(p)) module.exports[p] = m[p];
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $bAWmc = parcelRequire("bAWmc");


$6b362a72760d8152$var$__export((parcelRequire("5ixmT")));
/**
 * InvalidAriError - an error thrown if an invalid Ari is constructed
 */ var $6b362a72760d8152$var$InvalidAriError = /** @class */ function(_super) {
    $6b362a72760d8152$var$__extends(InvalidAriError, _super);
    /**
   * Construct an InvalidAriError given an error message
   *
   * @param {string} ariString - the ARI that failed to parse
   * @param {string|undefined} description - The error message
   */ function InvalidAriError(ariString, description) {
        var _this = _super.call(this, "Invalid ari string: " + ariString + (description ? '. ' + description : '')) || this;
        _this.ariString = ariString;
        // Support correct inheritance in ES5
        Object.setPrototypeOf(_this, InvalidAriError.prototype);
        return _this;
    }
    /**
   * Construct an InvalidAriError given some constraint violations
   *
   * @param {string} ariString - the ARI that failed to parse
   * @param {ConstraintViolation<Object>[]} violations - The array of constraint errors
   */ InvalidAriError.withConstraintViolations = function(ariString, violations) {
        return new InvalidAriError(ariString, violations.map(function(v) {
            return v.toString();
        }).join('\n'));
    };
    return InvalidAriError;
}(Error);
module.exports.InvalidAriError = $6b362a72760d8152$var$InvalidAriError;
function $6b362a72760d8152$var$matchesSegment(value1, value2) {
    if (value1 === value2) return true;
    else if (value1 === undefined) return true;
    return false;
}
// constraints are based on draft of v2 spec https://hello.atlassian.net/wiki/spaces/ARCH/pages/161909310/Atlassian+Resource+Identifier+Spec+draft-2.0#AtlassianResourceIdentifierSpec(draft-2.0)-Syntax
var $6b362a72760d8152$var$basicCharConstraint = $bAWmc.pattern(/^[a-z][a-z.-]*$/);
var $6b362a72760d8152$var$resourceOwnerConstraints = [
    $bAWmc.lengthBetween(3, 255),
    $6b362a72760d8152$var$basicCharConstraint
];
var $6b362a72760d8152$var$resourceTypeConstraints = [
    $bAWmc.lengthBetween(3, 255),
    $6b362a72760d8152$var$basicCharConstraint
];
var $6b362a72760d8152$var$cloudIdConstraints = [
    $bAWmc.lengthBetween(36, 255)
];
var $6b362a72760d8152$var$siteResourceType = 'site';
var $6b362a72760d8152$var$resourceIdChars = /[\w-._~:@#]/.source;
var $6b362a72760d8152$var$resourceIdConstraints = [
    $bAWmc.pattern(new RegExp("^" + $6b362a72760d8152$var$resourceIdChars + "+(/" + $6b362a72760d8152$var$resourceIdChars + "*)*(;v=" + $6b362a72760d8152$var$resourceIdChars + "*)*$"))
];
/**
 * Returns an Ari that is of the latest version of the Ari spec that we support. Any legacy formats
 * (like those for site wide ARIs) are upgraded to their latest form.
 */ function $6b362a72760d8152$var$upgrade(values) {
    var resourceId = values.resourceId, resourceOwner = values.resourceOwner, cloudId = values.cloudId;
    // note: The new ARI spec has not defined a format for system wide contexts so we exclude them from upgrade
    if (!resourceId && cloudId) return {
        resourceOwner: resourceOwner,
        resourceType: $6b362a72760d8152$var$siteResourceType,
        resourceId: cloudId
    };
    else return values;
}
var $6b362a72760d8152$var$ResourceIdentifier = /** @class */ function() {
    /**
   * Create a new Ari
   *
   * Only the resourceOwner is a required field, any other field can be omitted.
   * Older format types are converted on creation
   *
   * @param {string} values.resourceOwner - the owner of this resource (e.g. hipchat, confluence or jira)
   * @param {string|undefined} values.cloudId - the cloud id for this identifier, defined in AID
   * @param {string|undefined} values.resourceType - the resource type this Ari is associated with (e.g. conversation in hipchat)
   * @param {string|undefined} values.resourceId - a resource identifier, if this is specified the associated resourceType *must* be provided.
   *
   * @throws {InvalidAriError} if the provided segments fail to pass validation
   */ function ResourceIdentifier(values) {
        var _a = $6b362a72760d8152$var$upgrade(values), resourceId = _a.resourceId, resourceOwner = _a.resourceOwner, resourceType = _a.resourceType, cloudId = _a.cloudId;
        this.resourceOwner = resourceOwner;
        this.internalCloudId = cloudId;
        this.resourceType = resourceType;
        this.resourceId = resourceId;
        this.validate();
    }
    Object.defineProperty(ResourceIdentifier.prototype, "cloudId", {
        get: function() {
            if (this.resourceType === $6b362a72760d8152$var$siteResourceType) return this.internalCloudId ? this.internalCloudId : this.resourceId;
            return this.internalCloudId;
        },
        enumerable: true,
        configurable: true
    });
    /**
  * Parse a string as an Ari
  *
  * @param {string} ariString - the string to parse
  * @returns {Ari} the parsed ari
  * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
  */ ResourceIdentifier.parse = function(ariString) {
        if (!ariString) throw new $6b362a72760d8152$var$InvalidAriError(ariString);
        var match = ariString.match(/^ari:cloud:([^:/]+):([^:/]*):([^:/]*)\/(.*)$/);
        if (!match || match.length !== 5) throw new $6b362a72760d8152$var$InvalidAriError(ariString);
        var terms = match.map(function(a) {
            return a && a.length > 0 ? a : undefined;
        });
        var resourceOwner = terms[1];
        if (!resourceOwner) throw new $6b362a72760d8152$var$InvalidAriError(ariString);
        return new ResourceIdentifier({
            resourceOwner: resourceOwner,
            cloudId: terms[2],
            resourceType: terms[3],
            resourceId: terms[4]
        });
    };
    ResourceIdentifier.parseEncoded = function(encodedAriString) {
        return $6b362a72760d8152$var$parse(decodeURIComponent(encodedAriString));
    };
    /**
   * Converts this Ari to a string.
   */ ResourceIdentifier.prototype.toString = function() {
        if (!this.ariString) {
            var resourceId = this.resourceType === $6b362a72760d8152$var$siteResourceType && this.internalCloudId ? this.internalCloudId : this.resourceId || '';
            var resourceType = this.resourceType || '';
            var sanitizedCloudId = this.resourceType === $6b362a72760d8152$var$siteResourceType ? '' : this.internalCloudId || '';
            this.ariString = "ari:cloud:" + this.resourceOwner + ":" + sanitizedCloudId + ":" + resourceType + "/" + resourceId;
        }
        return this.ariString;
    };
    /**
   * Converts this object to its json representation
   */ ResourceIdentifier.prototype.toJSON = function() {
        return this.toString();
    };
    /**
   * Checks if this context is the same as another context
   *
   * @param {Ari} other - the other parameter to match with
   * @returns {boolean} - true if all segments of both Aris are equal, false otherwise
   */ ResourceIdentifier.prototype.equals = function(other) {
        return other instanceof ResourceIdentifier && this.resourceOwner === other.resourceOwner && this.cloudId === other.cloudId && this.resourceType === other.resourceType && this.resourceId === other.resourceId;
    };
    /**
   * This method checks if the current context contains the other context.
   *
   * Note: it does that by transforming a site context  (e.g. `ari:cloud:<resource owner>:site/<cloud id>`)
   * if required to an "any" resource type context (e.g. `ari:cloud:<resource owner>:<cloud id>:/`)
   *
   * @param {Ari} other
   * @returns {boolean}
   */ ResourceIdentifier.prototype.contains = function(other) {
        return this.matches(new ResourceIdentifier(other));
    };
    /**
   * Checks if this context is the same as or contains the provided context.
   *
   * Undefined segments in this ARI are treated as wildcards for matching purposes, but must exactly
   *  match if they are provided in the `other` Ari - i.e. this method is not commutative.
   *
   * e.g.
   * ```
   * parse('ari:cloud:hipchat::/').contains(parse('ari:cloud:hipchat:cloudid:conversation/blah')) === true
   * parse('ari:cloud:hipchat:cloudid:conversation/blah').contains(parse('ari:cloud:hipchat::/')) === false
   *
   * @param {Ari} other - the other parameter to match with
   * @returns {boolean} true if this Ari is the same as the other Ari, or matches the other Ari. False otherwise.
   */ ResourceIdentifier.prototype.matches = function(other) {
        return $6b362a72760d8152$var$matchesSegment(this.resourceOwner, other.resourceOwner) && $6b362a72760d8152$var$matchesSegment(this.cloudId, other.cloudId) && (this.resourceType === $6b362a72760d8152$var$siteResourceType && !!other.resourceType || $6b362a72760d8152$var$matchesSegment(this.resourceType, other.resourceType)) && (this.resourceType === $6b362a72760d8152$var$siteResourceType && !!other.resourceType || $6b362a72760d8152$var$matchesSegment(this.resourceId, other.resourceId));
    };
    ResourceIdentifier.prototype.validateSiteWide = function() {
        var _a = this, resourceType = _a.resourceType, cloudId = _a.cloudId;
        if (resourceType === $6b362a72760d8152$var$siteResourceType && !cloudId) return new $bAWmc.GeneralValidationError('site wide ARIs must have a cloudId');
    };
    ResourceIdentifier.prototype.validate = function() {
        var constraintViolations = [
            $bAWmc.validateField(this, 'resourceOwner', $6b362a72760d8152$var$resourceOwnerConstraints),
            $bAWmc.validateField(this, 'resourceType', $6b362a72760d8152$var$resourceTypeConstraints),
            $bAWmc.validateField(this, 'resourceId', $6b362a72760d8152$var$resourceIdConstraints),
            $bAWmc.validateField(this, 'cloudId', $6b362a72760d8152$var$cloudIdConstraints),
            this.validateSiteWide()
        ].filter(function(v) {
            return v;
        });
        if (constraintViolations.length > 0) throw $6b362a72760d8152$var$InvalidAriError.withConstraintViolations(this.toString(), constraintViolations);
        if (this.resourceId !== undefined && this.resourceType === undefined) throw new $6b362a72760d8152$var$InvalidAriError(this.toString(), 'The resource type must be specified if the resource id is defined.');
    };
    ResourceIdentifier.prototype.urlEncode = function() {
        return encodeURIComponent(this.toString());
    };
    ResourceIdentifier.prototype.urlDecode = function() {
        return decodeURIComponent(this.toString());
    };
    return ResourceIdentifier;
}();
module.exports.ResourceIdentifier = $6b362a72760d8152$var$ResourceIdentifier;
/**
 * Parse a string as an Ari
 *
 * @param {string} ariString - the string to parse
 * @returns {Ari} the parsed ari
 * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
 */ function $6b362a72760d8152$var$parse(ariString) {
    return $6b362a72760d8152$var$ResourceIdentifier.parse(ariString);
}
module.exports.parse = $6b362a72760d8152$var$parse;
/**
 * Parse a URL encoded string as an Ari
 *
 * @param {string} encodedAriString - the string to parse
 * @returns {Ari} the parsed ari
 * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
 */ function $6b362a72760d8152$var$parseEncoded(encodedAriString) {
    return $6b362a72760d8152$var$ResourceIdentifier.parseEncoded(encodedAriString);
}
module.exports.parseEncoded = $6b362a72760d8152$var$parseEncoded;

});

parcelRegister("bAWmc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $871053056dfd3da9$var$LengthConstraint = /** @class */ function() {
    function LengthConstraint(min, max) {
        this.min = min;
        this.max = max;
    }
    Object.defineProperty(LengthConstraint.prototype, "description", {
        get: function() {
            return "length must be between " + this.min + " and " + this.max;
        },
        enumerable: true,
        configurable: true
    });
    LengthConstraint.prototype.isValid = function(value) {
        return !value || value.length >= this.min && value.length <= this.max;
    };
    return LengthConstraint;
}();
module.exports.LengthConstraint = $871053056dfd3da9$var$LengthConstraint;
var $871053056dfd3da9$var$RegexConstraint = /** @class */ function() {
    function RegexConstraint(regex) {
        this.regex = regex;
    }
    Object.defineProperty(RegexConstraint.prototype, "description", {
        get: function() {
            return "value must match regex " + this.regex.source;
        },
        enumerable: true,
        configurable: true
    });
    RegexConstraint.prototype.isValid = function(value) {
        return !value || this.regex.test(value);
    };
    return RegexConstraint;
}();
module.exports.RegexConstraint = $871053056dfd3da9$var$RegexConstraint;
var $871053056dfd3da9$var$GeneralValidationError = /** @class */ function() {
    function GeneralValidationError(error) {
        this.error = error;
    }
    GeneralValidationError.prototype.toString = function() {
        return this.error;
    };
    return GeneralValidationError;
}();
module.exports.GeneralValidationError = $871053056dfd3da9$var$GeneralValidationError;
var $871053056dfd3da9$var$ConstraintViolation = /** @class */ function() {
    function ConstraintViolation(fieldName, value, constraints) {
        this.fieldName = fieldName;
        this.value = value;
        this.constraints = constraints;
    }
    ConstraintViolation.prototype.toString = function() {
        var constraintSummary = this.constraints.map(function(c) {
            return "  - " + c.description;
        }).join('\n');
        return "'" + this.value + "' is not a valid value for " + this.fieldName + " as it violates the following constraints:\n" + constraintSummary;
    };
    return ConstraintViolation;
}();
module.exports.ConstraintViolation = $871053056dfd3da9$var$ConstraintViolation;
function $871053056dfd3da9$var$lengthBetween(min, max) {
    return new $871053056dfd3da9$var$LengthConstraint(min, max);
}
module.exports.lengthBetween = $871053056dfd3da9$var$lengthBetween;
function $871053056dfd3da9$var$pattern(regex) {
    return new $871053056dfd3da9$var$RegexConstraint(regex);
}
module.exports.pattern = $871053056dfd3da9$var$pattern;
function $871053056dfd3da9$var$validateField(object, fieldName, constraints) {
    var value = object[fieldName];
    var violatedConstraints = constraints.map(function(c) {
        return c.isValid(value) ? undefined : c;
    }).filter(function(c) {
        return c;
    });
    return violatedConstraints.length > 0 ? new $871053056dfd3da9$var$ConstraintViolation(fieldName, value, violatedConstraints) : undefined;
}
module.exports.validateField = $871053056dfd3da9$var$validateField;

});

parcelRegister("5ixmT", function(module, exports) {
"use strict";
var $3db8846e4ba8de9f$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $199iK = parcelRequire("199iK");

var $3db8846e4ba8de9f$var$AppFamilyAri;
(function(AppFamilyAri) {
    AppFamilyAri.resourceOwner = 'ecosystem';
    AppFamilyAri.appResourceType = 'app';
    AppFamilyAri.environmentResourceType = 'environment';
    AppFamilyAri.extensionGroupResourceType = 'extension-group';
    AppFamilyAri.extensionResourceType = 'extension';
    AppFamilyAri.appFamilyResourceTypes = [
        AppFamilyAri.appResourceType,
        AppFamilyAri.environmentResourceType,
        AppFamilyAri.extensionGroupResourceType,
        AppFamilyAri.extensionResourceType
    ];
})($3db8846e4ba8de9f$var$AppFamilyAri = module.exports.AppFamilyAri || (module.exports.AppFamilyAri = {}));
var $3db8846e4ba8de9f$var$AppFamilyAriError = /** @class */ function(_super) {
    $3db8846e4ba8de9f$var$__extends(AppFamilyAriError, _super);
    function AppFamilyAriError(message, cause) {
        var _this = _super.call(this, message) || this;
        _this.cause = cause;
        return _this;
    }
    return AppFamilyAriError;
}(Error);
module.exports.AppFamilyAriError = $3db8846e4ba8de9f$var$AppFamilyAriError;
var $3db8846e4ba8de9f$var$NotAppFamilyAriError = /** @class */ function(_super) {
    $3db8846e4ba8de9f$var$__extends(NotAppFamilyAriError, _super);
    function NotAppFamilyAriError(ari, reason) {
        var _this = _super.call(this, "ari is not a valid App family ari: " + ari.toString() + " as " + reason) || this;
        _this.reason = reason;
        return _this;
    }
    return NotAppFamilyAriError;
}($3db8846e4ba8de9f$var$AppFamilyAriError);
module.exports.NotAppFamilyAriError = $3db8846e4ba8de9f$var$NotAppFamilyAriError;
var $3db8846e4ba8de9f$var$NotExpectedAppFamilyAriTypeError = /** @class */ function(_super) {
    $3db8846e4ba8de9f$var$__extends(NotExpectedAppFamilyAriTypeError, _super);
    function NotExpectedAppFamilyAriTypeError(type, ari, cause) {
        var _this = _super.call(this, "App family ari (" + ari.toString() + ") is not of expected type: " + type, cause) || this;
        _this.cause = cause;
        return _this;
    }
    return NotExpectedAppFamilyAriTypeError;
}($3db8846e4ba8de9f$var$AppFamilyAriError);
module.exports.NotExpectedAppFamilyAriTypeError = $3db8846e4ba8de9f$var$NotExpectedAppFamilyAriTypeError;
/**
 * throws NotAppFamilyAriError if not a valid app family ari
 */ function $3db8846e4ba8de9f$var$parseAppAri(ari) {
    return $199iK.AppFamilyAriImpl.parse(ari);
}
module.exports.parseAppAri = $3db8846e4ba8de9f$var$parseAppAri;
function $3db8846e4ba8de9f$var$createAppAri(json) {
    return new $199iK.AppFamilyAriImpl(json);
}
module.exports.createAppAri = $3db8846e4ba8de9f$var$createAppAri;

});

parcelRegister("199iK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $5ixmT = parcelRequire("5ixmT");


var $9cGsb = parcelRequire("9cGsb");

var $0d5dd8c916c95343$var$versionPrefix = ';v=';
var $0d5dd8c916c95343$var$AppFamilyAriImpl = /** @class */ function() {
    function AppFamilyAriImpl(json) {
        this.json = json;
    }
    Object.defineProperty(AppFamilyAriImpl.prototype, "appId", {
        get: function() {
            return this.json.appId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "environmentId", {
        get: function() {
            return this.json.environmentId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "version", {
        get: function() {
            return this.json.version;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "extensionGroupId", {
        get: function() {
            return this.json.extensionGroupId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "extensionKey", {
        get: function() {
            return this.json.extensionKey;
        },
        enumerable: true,
        configurable: true
    });
    AppFamilyAriImpl.prototype.toJSON = function() {
        return this.json;
    };
    AppFamilyAriImpl.parse = function(ari) {
        var resourceOwner = ari.resourceOwner, resourceType = ari.resourceType, resourceId = ari.resourceId;
        if (resourceOwner !== $5ixmT.AppFamilyAri.resourceOwner) throw new $5ixmT.NotAppFamilyAriError(ari, "resourceOwner (" + resourceOwner + ") must be " + $5ixmT.AppFamilyAri.resourceOwner);
        if (!resourceType || $5ixmT.AppFamilyAri.appFamilyResourceTypes.indexOf(resourceType) < 0) throw new $5ixmT.NotAppFamilyAriError(ari, "resourceType must be one of " + $5ixmT.AppFamilyAri.appFamilyResourceTypes);
        if (!resourceId) throw new $5ixmT.NotAppFamilyAriError(ari, 'resourceId is must be provided');
        var versionIndex = resourceId.indexOf($0d5dd8c916c95343$var$versionPrefix);
        if (versionIndex > 0 && resourceId.lastIndexOf($0d5dd8c916c95343$var$versionPrefix) > versionIndex) throw new $5ixmT.NotAppFamilyAriError(ari, 'can only include one version suffix');
        var _a = resourceId.split($0d5dd8c916c95343$var$versionPrefix), mainResourceId = _a[0], version = _a[1];
        var segments = mainResourceId.split('/').map($0d5dd8c916c95343$var$stripToUndefined);
        if (segments.length > 4) throw new $5ixmT.NotAppFamilyAriError(ari, "no path segments can be added after extensionKey " + segments.slice(4));
        var _b = segments[0], appId = _b === void 0 ? undefined : _b, _c = segments[1], environmentId = _c === void 0 ? undefined : _c, _d = segments[2], providedExtensionGroupId = _d === void 0 ? undefined : _d, _e = segments[3], extensionKey = _e === void 0 ? undefined : _e;
        if (!appId) throw new $5ixmT.NotAppFamilyAriError(ari, 'appId must be included');
        var extensionGroupId = providedExtensionGroupId || (resourceType === $5ixmT.AppFamilyAri.extensionGroupResourceType || resourceType === $5ixmT.AppFamilyAri.extensionResourceType ? 'static' : undefined);
        if (resourceType === $5ixmT.AppFamilyAri.extensionResourceType && !(environmentId && providedExtensionGroupId && extensionKey)) throw new $5ixmT.NotAppFamilyAriError(ari, "environmentId, extensionGroupId, extensionKey must all be provided for resourceType " + $5ixmT.AppFamilyAri.extensionResourceType);
        else if (resourceType === $5ixmT.AppFamilyAri.extensionGroupResourceType && (!(environmentId && extensionGroupId) || extensionKey)) throw new $5ixmT.NotAppFamilyAriError(ari, "environmentId, extensionGroupId must all be provided for resourceType " + $5ixmT.AppFamilyAri.extensionGroupResourceType);
        else if (resourceType === $5ixmT.AppFamilyAri.environmentResourceType && (!environmentId || providedExtensionGroupId || extensionKey)) throw new $5ixmT.NotAppFamilyAriError(ari, "environmentId must be provided for resourceType " + $5ixmT.AppFamilyAri.environmentResourceType);
        else if (resourceType === $5ixmT.AppFamilyAri.appResourceType && (environmentId || providedExtensionGroupId || extensionKey)) throw new $5ixmT.NotAppFamilyAriError(ari, "environmentId must be provided for resourceType " + $5ixmT.AppFamilyAri.environmentResourceType);
        return new AppFamilyAriImpl({
            appId: appId,
            environmentId: environmentId,
            extensionGroupId: extensionGroupId,
            extensionKey: extensionKey,
            version: version
        });
    };
    AppFamilyAriImpl.prototype.asAppAri = function() {
        var _this = this;
        return this.returnIf(function() {
            return _this.isAppAri();
        }, 'app');
    };
    AppFamilyAriImpl.prototype.asAppEnvironmentAri = function() {
        var _this = this;
        return this.returnIf(function() {
            return _this.isAppEnvironmentAri();
        }, 'environment');
    };
    AppFamilyAriImpl.prototype.asExtensionGroupAri = function() {
        var _this = this;
        return this.returnIf(function() {
            return _this.isExtensionGroupAri();
        }, 'extension-group');
    };
    AppFamilyAriImpl.prototype.asExtensionAri = function() {
        var _this = this;
        return this.returnIf(function() {
            return _this.isExtensionAri();
        }, 'extension');
    };
    AppFamilyAriImpl.prototype.isAppAri = function() {
        return !this.isAtLeastAppEnvironmentAri;
    };
    AppFamilyAriImpl.prototype.isAppEnvironmentAri = function() {
        return this.isAtLeastAppEnvironmentAri && !this.isAtLeastExtensionGroupAri;
    };
    AppFamilyAriImpl.prototype.isExtensionGroupAri = function() {
        return this.isAtLeastExtensionGroupAri && !this.isExtensionAri();
    };
    AppFamilyAriImpl.prototype.isExtensionAri = function() {
        return this.isAtLeastExtensionGroupAri && this.extensionKey !== undefined;
    };
    AppFamilyAriImpl.prototype.returnIf = function(check, type) {
        if (!check()) throw new $5ixmT.NotExpectedAppFamilyAriTypeError(type, this);
        return this; // :sadpanda:
    };
    Object.defineProperty(AppFamilyAriImpl.prototype, "isAtLeastAppEnvironmentAri", {
        get: function() {
            return this.environmentId !== undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "isAtLeastExtensionGroupAri", {
        get: function() {
            return this.isAtLeastAppEnvironmentAri && this.extensionGroupId !== undefined;
        },
        enumerable: true,
        configurable: true
    });
    AppFamilyAriImpl.prototype.toAri = function() {
        var resourceOwner = $5ixmT.AppFamilyAri.resourceOwner;
        var _a = this.toJSON(), appId = _a.appId, environmentId = _a.environmentId, extensionGroupId = _a.extensionGroupId, extensionKey = _a.extensionKey, version = _a.version;
        function withVersion(segments) {
            var path = segments.join('/');
            if (!version) return path;
            else return "" + path + $0d5dd8c916c95343$var$versionPrefix + version;
        }
        if (this.isExtensionAri()) return new $9cGsb.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $5ixmT.AppFamilyAri.extensionResourceType,
            resourceId: withVersion([
                appId,
                environmentId,
                extensionGroupId,
                extensionKey
            ])
        });
        else if (this.isExtensionGroupAri()) return new $9cGsb.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $5ixmT.AppFamilyAri.extensionGroupResourceType,
            resourceId: withVersion([
                appId,
                environmentId,
                extensionGroupId
            ])
        });
        else if (this.isAppEnvironmentAri()) return new $9cGsb.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $5ixmT.AppFamilyAri.environmentResourceType,
            resourceId: withVersion([
                appId,
                environmentId
            ])
        });
        else return new $9cGsb.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $5ixmT.AppFamilyAri.appResourceType,
            resourceId: appId
        });
    };
    AppFamilyAriImpl.prototype.toString = function() {
        return this.toAri().toString();
    };
    return AppFamilyAriImpl;
}();
module.exports.AppFamilyAriImpl = $0d5dd8c916c95343$var$AppFamilyAriImpl;
function $0d5dd8c916c95343$var$stripToUndefined(str) {
    if (!str) return undefined;
    var trimmed = str.trim();
    if (trimmed.length === 0) return undefined;
    return trimmed;
}

});

parcelRegister("k9rxT", function(module, exports) {
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $eaCYh = parcelRequire("eaCYh");


var $3ETCd = parcelRequire("3ETCd");


var $anJMe = parcelRequire("anJMe");


var $fcFES = parcelRequire("fcFES");

class $f4cb6c0703060f5e$export$60449a906da67814 extends (0, $3ETCd.AbstractPresenceResource) {
    refreshPresence(userIds) {
        const cacheHits = this.presenceCache.getBulk(userIds);
        this.notifyListeners(cacheHits);
        const cacheMisses = this.presenceCache.getMissingUserIds(userIds);
        if (cacheMisses.length) this.retrievePresence(cacheMisses);
    }
    retrievePresence(userIds) {
        this.queryDirectoryForPresences(userIds).then((res)=>this.presenceParser.parse(res)).then((presences)=>{
            this.notifyListeners(presences);
            this.presenceCache.update(presences);
        });
    }
    queryDirectoryForPresences(userIds) {
        const query = {
            query: `query getPresenceForMentions($organizationId: String!, $userIds: [String!], $productId: String) {
                PresenceBulk(organizationId: $organizationId, product: $productId, userIds: $userIds) {
                  userId
                  state
                  stateMetadata
                }
              }`,
            variables: {
                organizationId: this.config.cloudId,
                userIds: userIds
            }
        };
        if (this.config.productId) query.variables['productId'] = this.config.productId;
        const atlAttributionHeader = (0, $eaCYh.buildAtlAttributionHeaderValue)({
            cloudId: this.config.cloudId,
            productId: this.config.productId,
            activationId: this.config.activationId
        });
        const options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...atlAttributionHeader,
                ...this.config.headers
            },
            credentials: 'include',
            body: JSON.stringify(query)
        };
        return fetch(this.config.url, options).then((response)=>response.json());
    }
    static cleanUrl(url) {
        if (url.substr(-1) !== '/') url += '/';
        return url;
    }
    constructor(config){
        super();
        this.config = void 0;
        this.presenceCache = void 0;
        this.presenceParser = void 0;
        if (!config.url) throw new Error('config.url is a required parameter');
        if (!config.cloudId) throw new Error('config.cloudId is a required parameter');
        this.config = config;
        this.config.url = $f4cb6c0703060f5e$export$60449a906da67814.cleanUrl(config.url);
        this.presenceCache = config.cache || new (0, $anJMe.DefaultPresenceCache)(config.cacheExpiry);
        this.presenceParser = config.parser || new (0, $fcFES.DefaultPresenceParser)();
    }
}
var $f4cb6c0703060f5e$export$2e2bcd8739ae039 = $f4cb6c0703060f5e$export$60449a906da67814;
module.exports["default"] = $f4cb6c0703060f5e$export$2e2bcd8739ae039;

});

parcelRegister("eaCYh", function(module, exports) {
function $669159666a118337$export$9df8b8301f41e4b7(config) {
    const { cloudId: cloudId, activationId: activationId, productId: productId = 'platform' } = config;
    const value = {
        tenantId: cloudId,
        product: productId
    };
    if (activationId) value.atlWorkspaceId = `ari:cloud:${productId}:${cloudId}:workspace/${activationId}`;
    return {
        'atl-attribution': JSON.stringify(value)
    };
}
module.exports["buildAtlAttributionHeaderValue"] = $669159666a118337$export$9df8b8301f41e4b7;

});

parcelRegister("3ETCd", function(module, exports) {

var $2SUNK = parcelRequire("2SUNK");


var $dvMxu = parcelRequire("dvMxu");

class $4bf5f554e4571238$export$7b4524ed61cc8203 extends (0, $dvMxu.AbstractResource) {
    refreshPresence(userIds) {
        throw new Error(`not yet implemented.\nParams: userIds=${userIds}`);
    }
    notifyListeners(presences) {
        this.changeListeners.forEach((listener, key)=>{
            try {
                listener(presences);
            } catch (e) {
                // ignore error from listener
                (0, $2SUNK.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
}
module.exports["AbstractPresenceResource"] = $4bf5f554e4571238$export$7b4524ed61cc8203;

});

parcelRegister("dvMxu", function(module, exports) {
class $5c4239d07c0ef4c8$export$4529f10aed0950d4 {
    subscribe(key, callback, errCallback, infoCallback, allResultsCallback, analyticsListeners) {
        if (callback) this.changeListeners.set(key, callback);
        if (errCallback) this.errListeners.set(key, errCallback);
        if (infoCallback) this.infoListeners.set(key, infoCallback);
        if (allResultsCallback) this.allResultsListeners.set(key, allResultsCallback);
        if (analyticsListeners) this.analyticsListeners.set(key, analyticsListeners);
    }
    unsubscribe(key) {
        this.changeListeners.delete(key);
        this.errListeners.delete(key);
        this.infoListeners.delete(key);
        this.allResultsListeners.delete(key);
        this.analyticsListeners.delete(key);
    }
    constructor(){
        this.changeListeners = void 0;
        this.errListeners = void 0;
        this.infoListeners = void 0;
        this.allResultsListeners = void 0;
        this.analyticsListeners = void 0;
        this.changeListeners = new Map();
        this.allResultsListeners = new Map();
        this.errListeners = new Map();
        this.infoListeners = new Map();
        this.analyticsListeners = new Map();
    }
}
module.exports["AbstractResource"] = $5c4239d07c0ef4c8$export$4529f10aed0950d4;

});

parcelRegister("anJMe", function(module, exports) {
class $cb82e10138ad9a17$var$CacheEntry {
    expired() {
        return Date.now() > this.expiry;
    }
    constructor(pres, timeout){
        this.presence = void 0;
        this.expiry = void 0;
        this.presence = pres;
        this.expiry = Date.now() + timeout;
    }
}
class $cb82e10138ad9a17$export$f962b6f1aaaafaf5 {
    /**
   * Precondition: _delete is only called internally if userId exists in cache
   * Removes cache entry
   * @param userId
   */ _delete(userId) {
        delete this.cache[userId];
        this.size--;
    }
    /**
   * Checks a cache entry and calls delete if the info has expired
   * @param userId
   */ _deleteIfExpired(userId) {
        if (this.contains(userId) && this.cache[userId].expired()) this._delete(userId);
    }
    /**
   * Cleans expired entries from cache
   */ _removeExpired() {
        Object.keys(this.cache).forEach((id)=>{
            this._deleteIfExpired(id);
        });
    }
    /**
   * Checks if a user exists in the cache
   * @param userId
   */ contains(userId) {
        return this.cache.hasOwnProperty(userId);
    }
    /**
   * Retrieves a presence from the cache after checking for expired entries
   * @param userId - to index the cache
   * @returns Presence - the presence that matches the userId
   */ get(userId) {
        this._deleteIfExpired(userId);
        if (!this.contains(userId)) return {};
        return this.cache[userId].presence;
    }
    /**
   * Retrieve multiple presences at once from the cache
   * @param userIds - to index the cache
   * @returns PresenceMap - A map of userIds to cached Presences
   */ getBulk(userIds) {
        const presences = {};
        for (const userId of userIds)if (this.contains(userId)) presences[userId] = this.get(userId);
        return presences;
    }
    /**
   * For a given list of ids, returns a subset
   * of all the ids with missing cache entries.
   * @param userIds - to index the cache
   * @returns string[] - ids missing from the cache
   */ getMissingUserIds(userIds) {
        return userIds.filter((id)=>!this.contains(id));
    }
    /**
   * Precondition: presMap only contains ids of users not in cache
   *               expired users must first be removed then reinserted with updated presence
   * Updates the cache by adding the new Presence entries and setting the expiry time
   * @param presMap
   */ update(presMap) {
        if (this.size >= this.flushTrigger) this._removeExpired();
        Object.keys(presMap).forEach((userId)=>{
            this.cache[userId] = new $cb82e10138ad9a17$var$CacheEntry(presMap[userId], this.expiryInMillis);
            this.size++;
        });
    }
    constructor(cacheTimeout, cacheTrigger){
        this.cache = void 0;
        this.size = void 0;
        this.expiryInMillis = void 0;
        this.flushTrigger = void 0;
        this.expiryInMillis = cacheTimeout ? cacheTimeout : $cb82e10138ad9a17$export$f962b6f1aaaafaf5.defaultTimeout;
        this.flushTrigger = cacheTrigger ? cacheTrigger : $cb82e10138ad9a17$export$f962b6f1aaaafaf5.defaultFlushTrigger;
        this.cache = {};
        this.size = 0;
    }
}
$cb82e10138ad9a17$export$f962b6f1aaaafaf5.defaultTimeout = 20000;
$cb82e10138ad9a17$export$f962b6f1aaaafaf5.defaultFlushTrigger = 50;
module.exports["DefaultPresenceCache"] = $cb82e10138ad9a17$export$f962b6f1aaaafaf5;

});

parcelRegister("fcFES", function(module, exports) {
class $5a1745191e76205a$export$80bae4549cafd20d {
    mapState(state) {
        if (state === 'unavailable') return 'offline';
        else if (state === 'available') return 'online';
        else return state;
    }
    parse(response) {
        const presences = {};
        if (response.hasOwnProperty('data') && response['data'].hasOwnProperty('PresenceBulk')) {
            const results = response['data'].PresenceBulk;
            // Store map of state and time indexed by userId.  Ignore null results.
            for (const user of results){
                if (user.userId && user.state) {
                    const state = $5a1745191e76205a$export$80bae4549cafd20d.extractState(user) || user.state;
                    presences[user.userId] = {
                        status: this.mapState(state)
                    };
                } else if (!user.hasOwnProperty('userId') || !user.hasOwnProperty('state')) // eslint-disable-next-line no-console
                console.error('Unexpected response from presence service contains keys: ' + Object.keys(user));
            }
        }
        return presences;
    }
    static extractState(presence) {
        if ($5a1745191e76205a$export$80bae4549cafd20d.isFocusState(presence)) return $5a1745191e76205a$export$80bae4549cafd20d.FOCUS_STATE;
        return presence.state;
    }
    /*
     This is a bit of an odd exception. In the case where a user is in "Focus Mode", their presence state
     is returned as 'busy' along with a `stateMetadata` object containing a `focus` field.
     In this case we ignore the value of the `state` field and treat the presence as a 'focus' state.
    */ static isFocusState(presence) {
        if (presence.stateMetadata) try {
            const metadata = JSON.parse(presence.stateMetadata);
            return metadata && !!metadata.focus;
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(`Failed to parse presence's stateMetadata for user with id ${presence.userId}: ${presence.stateMetadata}`);
            // eslint-disable-next-line no-console
            console.error(e);
        }
        return false;
    }
}
$5a1745191e76205a$export$80bae4549cafd20d.FOCUS_STATE = 'focus';
module.exports["DefaultPresenceParser"] = $5a1745191e76205a$export$80bae4549cafd20d;

});

parcelRegister("bje9P", function(module, exports) {

var $caelp = parcelRequire("caelp");


var $d7tjP = parcelRequire("d7tjP");


var $fnGw7 = parcelRequire("fnGw7");

class $64c10b9731bd9a19$export$2ae0434dccdcb77e {
    lookupName(id) {
        const name = this.nameCache.get(id);
        if (name) {
            this.fireAnalytics(true, name);
            if (this.nameQueue.size === 0) this.scheduleOnAllResolved();
            return name;
        }
        return new Promise((resolve)=>{
            const processingItems = this.processingQueue.get(id);
            if (processingItems) this.processingQueue.set(id, [
                ...processingItems,
                resolve
            ]);
            const queuedItems = this.nameQueue.get(id) || [];
            this.nameQueue.set(id, [
                ...queuedItems,
                resolve
            ]);
            if (queuedItems.length === 0 && !processingItems) this.nameStartTime.set(id, Date.now());
            this.scheduleProcessQueue();
            if (this.isQueueAtLimit()) this.processQueue();
        });
    }
    cacheName(id, name) {
        this.nameCache.set(id, {
            id: id,
            name: name,
            status: (0, $caelp.MentionNameStatus).OK
        });
    }
    scheduleProcessQueue() {
        if (!this.debounce) this.debounce = window.setTimeout(this.processQueue, $64c10b9731bd9a19$export$2ae0434dccdcb77e.waitForBatch);
    }
    scheduleOnAllResolved() {
        if (this.debounceOnResolve) clearTimeout(this.debounceOnResolve);
        this.debounceOnResolve = window.setTimeout(()=>{
            if (this.isOnResolvedAllCalled) return;
            this.onResolvedAll();
            this.isOnResolvedAllCalled = true;
        }, $64c10b9731bd9a19$export$2ae0434dccdcb77e.waitForResolveAll);
    }
    isQueueAtLimit() {
        return this.nameQueue.size >= this.client.getLookupLimit();
    }
    splitQueueAtLimit() {
        const values = Array.from(this.nameQueue.entries());
        const splitPoint = this.client.getLookupLimit();
        return {
            queue: new Map(values.slice(0, splitPoint)),
            extraQueue: new Map(values.slice(splitPoint))
        };
    }
    resolveQueueItem(mentionDetail) {
        const { id: id } = mentionDetail;
        const resolvers = this.processingQueue.get(id);
        if (resolvers) {
            this.processingQueue.delete(id);
            this.nameCache.set(id, mentionDetail);
            resolvers.forEach((resolve)=>{
                try {
                    resolve(mentionDetail);
                } catch  {
                // ignore - exception in consumer
                }
            });
            this.fireAnalytics(false, mentionDetail);
        }
    }
    fireAnalytics(fromCache, mentionDetail) {
        const { id: id } = mentionDetail;
        const action = mentionDetail.status === (0, $caelp.MentionNameStatus).OK ? 'completed' : 'failed';
        const start = this.nameStartTime.get(id);
        const duration = start ? Date.now() - start : 0;
        this.nameStartTime.delete(id);
        this.fireHydrationEvent(action, id, fromCache, duration);
    }
    constructor(client, analyticsProps = {}, onResolvedAll = ()=>{}){
        // ms
        this.client = void 0;
        this.nameCache = new Map();
        this.nameQueue = new Map();
        this.nameStartTime = new Map();
        this.processingQueue = new Map();
        this.debounce = 0;
        this.debounceOnResolve = null;
        this.onResolvedAll = void 0;
        this.isOnResolvedAllCalled = false;
        this.fireHydrationEvent = void 0;
        this.processQueue = ()=>{
            clearTimeout(this.debounce);
            this.debounce = 0;
            const { queue: queue, extraQueue: extraQueue } = this.splitQueueAtLimit();
            this.nameQueue = extraQueue;
            this.processingQueue = (0, $fnGw7.mergeNameResolverQueues)(this.processingQueue, queue);
            this.client.lookupMentionNames(Array.from(queue.keys())).then((response)=>{
                response.forEach((mentionDetail)=>{
                    const { id: id } = mentionDetail;
                    queue.delete(id);
                    this.resolveQueueItem(mentionDetail);
                });
                queue.forEach((_callback, id)=>{
                    // No response from client for these ids treat as unknown
                    this.resolveQueueItem({
                        id: id,
                        status: (0, $caelp.MentionNameStatus).UNKNOWN
                    });
                });
            }).catch(()=>{
                // Service completely failed, reject all items in the queue
                queue.forEach((_callback, id)=>{
                    this.resolveQueueItem({
                        id: id,
                        status: (0, $caelp.MentionNameStatus).SERVICE_ERROR
                    });
                });
            });
            // Make sure anything left in the queue gets processed.
            if (this.nameQueue.size > 0) this.scheduleProcessQueue();
            else this.scheduleOnAllResolved();
        };
        this.client = client;
        this.fireHydrationEvent = (0, $d7tjP.fireAnalyticsMentionHydrationEvent)(analyticsProps);
        // If provided, this will be called once all pending mentions in the queue are resolved.
        // A sample usage is scrolling to a mention on page load, after the mentions have loadad.
        this.onResolvedAll = onResolvedAll;
    }
}
$64c10b9731bd9a19$export$2ae0434dccdcb77e.waitForBatch = 100;
// ms
$64c10b9731bd9a19$export$2ae0434dccdcb77e.waitForResolveAll = 800;
module.exports["DefaultMentionNameResolver"] = $64c10b9731bd9a19$export$2ae0434dccdcb77e;

});

parcelRegister("d7tjP", function(module, exports) {

var $852mP = parcelRequire("852mP");


var $4cczm = parcelRequire("4cczm");


var $caelp = parcelRequire("caelp");


var $4B8nE = parcelRequire("4B8nE");


var $iu9yU = parcelRequire("iu9yU");

const $7638fcfba6821dc7$export$91b2fa6a0fe06408 = (props)=>(action, userId, fromCache, duration)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = {
                action: action,
                actionSubject: (0, $caelp.ComponentNames).MENTION,
                actionSubjectId: 'hydration',
                attributes: {
                    packageName: $4B8nE.packageName,
                    packageVersion: $iu9yU.packageVersion,
                    componentName: (0, $caelp.ComponentNames).MENTION,
                    userId: userId,
                    fromCache: fromCache,
                    duration: Math.round(duration)
                },
                eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE)
            };
            const analyticsEvent = props.createAnalyticsEvent(eventPayload);
            analyticsEvent.fire((0, $4cczm.ELEMENTS_CHANNEL));
        }
    };
module.exports["fireAnalyticsMentionHydrationEvent"] = $7638fcfba6821dc7$export$91b2fa6a0fe06408;

});

parcelRegister("fnGw7", function(module, exports) {
function $89691861f49f9b0f$export$71ea0798a8cad7d8(queueA, queueB) {
    const queueBeingMerged = new Map([
        ...queueA
    ]);
    // now add the items from the second queue that are not already in the
    //  merged queue being built
    [
        ...queueB
    ].forEach((item)=>{
        const [key, queueBCallbacks] = item;
        const itemAlreadyInMergedQueue = queueBeingMerged.has(key);
        if (!itemAlreadyInMergedQueue) queueBeingMerged.set(key, queueBCallbacks);
        else {
            // item already in merged queue, merge the callback arrays
            const queueACallbacks = queueBeingMerged.get(key) ?? [];
            const mergedCallbacks = new Set([
                ...queueBCallbacks,
                ...queueACallbacks
            ]);
            const deduplicatedCallbacks = Array.from(mergedCallbacks.values()); // prevents calling them twice
            queueBeingMerged.set(key, deduplicatedCallbacks);
        }
    });
    return queueBeingMerged;
}
module.exports["mergeNameResolverQueues"] = $89691861f49f9b0f$export$71ea0798a8cad7d8;

});

parcelRegister("80Dol", function(module, exports) {

var $bijHC = parcelRequire("bijHC");


var $b3nqj = parcelRequire("b3nqj");


var $caelp = parcelRequire("caelp");


var $f7B1p = parcelRequire("f7B1p");


var $ge2sX = parcelRequire("ge2sX");


var $9fywD = parcelRequire("9fywD");


var $04e9M = parcelRequire("04e9M");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $5CrKL = parcelRequire("5CrKL");


var $j5rtD = parcelRequire("j5rtD");


var $gYPwD = parcelRequire("gYPwD");

const $76cb501321125a14$var$INITIAL_STATE = 'initialState';
const $76cb501321125a14$var$SEARCH = 'searchUser';
const $76cb501321125a14$var$SUCCEEDED = 'succeeded';
const $76cb501321125a14$var$FAILED = 'failed';
const $76cb501321125a14$var$CONTEXT_TYPE = 'Mentions';
/**
 * MAX_NOTIFIED_ITEMS in platform/packages/elements/mention/src/api/MentionResource.ts limits how many mentions returned by UserTeamMentionProvider will be used really! 20 is its value at the time of this writing.
 */ const $76cb501321125a14$var$MAX_RESULTS = 20;
/**
 * platform/packages/editor/editor-plugin-mentions/src/ui/type-ahead/index.tsx sections the mentions returned by UserTeamMentionProvider in agents and non-agents (such as people and teams).
 * But it also defines its own limit per section! 5 is its limit for agents at the time of this writing.
 * So to see both agents and people/non-agents in the sectioned UI, UserTeamMentionProvider needs to arrange enough of each section into the first MAX_RESULTS mentions it returns.
 */ const $76cb501321125a14$var$MIN_AGENT_RESULTS = 5;
// Use in memory cache only
const $76cb501321125a14$var$defaultCache = {
    getStoredValues: ()=>Promise.resolve(new Map()),
    setStoredValues: ()=>Promise.resolve()
};
class $76cb501321125a14$export$f500b4849378edff extends (0, $bijHC.MentionResource) {
    /**
   * Overrides `remoteInitialState` from `MentionResource`
   * This is invoked for bootstrap/empty queries,
   */ async remoteInitialState(contextIdentifier) {
        try {
            const promise = await this.doSearch('', contextIdentifier);
            // Set initial cache
            if ((0, $6mKj3.expValEquals)('platform_editor_offline_editing_web', 'isEnabled', true)) this.offlineCache?.set(this.userTeamEndpoint, promise);
            this._notifyAnalyticsListeners((0, $b3nqj.SLI_EVENT_TYPE), $76cb501321125a14$var$INITIAL_STATE, $76cb501321125a14$var$SUCCEEDED);
            return promise;
        } catch (e) {
            this._notifyAnalyticsListeners((0, $b3nqj.SLI_EVENT_TYPE), $76cb501321125a14$var$INITIAL_STATE, $76cb501321125a14$var$FAILED);
            throw e;
        }
    }
    /**
   * Overrides `remoteSearch` from `MentionResource`
   * This is invoked for non-empty queries.
   */ async remoteSearch(query, contextIdentifier) {
        try {
            const promise = await this.doSearch(query, contextIdentifier);
            this._notifyAnalyticsListeners((0, $b3nqj.SLI_EVENT_TYPE), $76cb501321125a14$var$SEARCH, $76cb501321125a14$var$SUCCEEDED);
            return promise;
        } catch (e) {
            this._notifyAnalyticsListeners((0, $b3nqj.SLI_EVENT_TYPE), $76cb501321125a14$var$SEARCH, $76cb501321125a14$var$FAILED);
            throw e;
        }
    }
    async getCachedValue(query) {
        const cachedValue = this.offlineCache?.get(this.userTeamEndpoint);
        if (!cachedValue) return undefined;
        if (query === '') return Promise.resolve(cachedValue);
        else {
            // If we're offline allow basic filtering of the cached results by name.
            if (window?.navigator.onLine === false) return Promise.resolve({
                query: query,
                mentions: cachedValue.mentions?.filter((v)=>v?.name?.toLowerCase().includes(query.toLowerCase()) || v?.mentionName?.toLowerCase().includes(query.toLowerCase()) || v?.nickname?.toLowerCase().includes(query.toLowerCase()))
            });
        }
    }
    async doSearch(query, contextIdentifier) {
        if ((0, $6mKj3.expValEquals)('platform_editor_offline_editing_web', 'isEnabled', true)) {
            const cachedValue = await this.getCachedValue(query);
            // Use stale-while-revalidate - if the cached value exists use it first and
            // update the cache value in the background so that it's up to date when the
            // next call is made
            if (cachedValue) {
                if (query === '') this.doNetworkSearch(query, contextIdentifier).then((results)=>{
                    this.offlineCache?.set(this.userTeamEndpoint, results);
                }).catch(()=>{
                // Pass, it's okay if the cache doesn't update
                });
                return cachedValue;
            }
            return this.doNetworkSearch(query, contextIdentifier);
        } else return this.doNetworkSearch(query, contextIdentifier);
    }
    async doNetworkSearch(query, contextIdentifier) {
        (0, $5CrKL.MENTIONS_QUERY_METRIC).start();
        const [response, agentMentionsResult] = await Promise.all([
            this.post(await this.cloudId(), await this.orgId(), query, contextIdentifier),
            this.includeAgents ? (0, $gYPwD.queryAgentMentions)(query, $76cb501321125a14$var$MAX_RESULTS).catch(()=>/* Do not let queryAgentMentions break the production-available people and teams search. */ ({
                    mentions: [],
                    query: query
                })) : undefined
        ]);
        if (!response.ok) {
            const errorBody = await response.json();
            (0, $5CrKL.MENTIONS_QUERY_METRIC).stop({
                customData: {
                    isExCoEnabled: this.includeExternalCollaborators,
                    success: false
                }
            });
            throw new Error(JSON.stringify(errorBody));
        }
        const body = await response.json();
        const mentions = body.recommendedUsers.map((recommended)=>{
            if (this.isAgent(recommended)) return this.convertToAgentMention(recommended);
            if (this.isUser(recommended)) return this.convertToUserMention(recommended);
            if (this.isTeam(recommended)) return this.convertToTeamMention(recommended);
            // Fallback to user mention for unknown types
            return this.convertToUserMention(recommended);
        });
        let jiraMentions = [];
        if (mentions.length < $76cb501321125a14$var$MAX_RESULTS && this.isEligibleXProductUserInvite && await this.isEligibleXProductUserInvite()) try {
            const jiraResponse = await this.searchXproductUsers(await this.cloudId(), await this.orgId(), query, contextIdentifier);
            if (!jiraResponse.ok) {
                const errorBody = await jiraResponse.json();
                throw new Error(JSON.stringify(errorBody));
            }
            const jiraBody = await jiraResponse.json();
            // Remove objects from jiraMentions if an object with the same id is present in mentions
            const mentionIds = new Set(mentions.map((mention)=>mention.id));
            const recommendedJiraUsers = (jiraBody.recommendedUsers || []).filter((mention)=>!mentionIds.has(mention?.id)).slice(0, $76cb501321125a14$var$MAX_RESULTS - mentions.length);
            //only evaluate the experiment cohort if there are jira mentions to show
            if (recommendedJiraUsers.length > 0 && (0, $6mKj3.expValEquals)('cc_virality_x_product_user_invite', 'cohort', 'test')) jiraMentions = recommendedJiraUsers.map((recommended)=>{
                return {
                    ...this.convertToUserMention(recommended),
                    isXProductUser: true
                };
            });
        } catch (error) {
            const client = await (0, $04e9M.getAnalyticsWebClient)();
            const errorMessages = error instanceof Error ? error.message : String(error);
            client.sendOperationalEvent({
                source: 'editor',
                action: 'errored',
                actionSubject: 'xProductUserSearch',
                attributes: {
                    error: errorMessages,
                    stack: error?.stack
                }
            });
        }
        (0, $5CrKL.MENTIONS_QUERY_METRIC).stop({
            customData: {
                isExCoEnabled: this.includeExternalCollaborators,
                success: true
            }
        });
        let agentMentions = agentMentionsResult?.mentions ?? [];
        let nonAgentMentions = [
            ...mentions,
            ...jiraMentions
        ];
        if (agentMentions.length) {
            // Studio agent results should win if URS ever returns the same agent ID.
            const agentMentionIds = new Set(agentMentions.map((mention)=>mention.id));
            nonAgentMentions = nonAgentMentions.filter((mention)=>!agentMentionIds.has(mention.id));
            agentMentions = agentMentions.slice(0, Math.max($76cb501321125a14$var$MIN_AGENT_RESULTS, $76cb501321125a14$var$MAX_RESULTS - nonAgentMentions.length));
        }
        return {
            query: query,
            mentions: [
                ...agentMentions,
                ...nonAgentMentions
            ]
        };
    }
    async cloudId() {
        const { cloudId: cloudId } = await (0, $ge2sX.getSessionData)();
        return cloudId;
    }
    async orgId() {
        const { orgId: orgId } = await (0, $ge2sX.getSessionData)();
        return orgId;
    }
    async post(cloudId, orgId, query, contextIdentifier) {
        return await (0, $f7B1p.cfetch)(this.userTeamEndpoint, {
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify({
                context: {
                    contextType: $76cb501321125a14$var$CONTEXT_TYPE,
                    principalId: 'context',
                    productKey: contextIdentifier && contextIdentifier.product || 'confluence',
                    // defaults to 'confluence' to work with old editor
                    siteId: cloudId,
                    containerId: contextIdentifier && contextIdentifier.containerId,
                    objectId: contextIdentifier && contextIdentifier.objectId,
                    childObjectId: contextIdentifier && contextIdentifier.childObjectId,
                    mentionsSessionId: contextIdentifier && contextIdentifier.sessionId,
                    ...orgId ? {
                        organizationId: orgId
                    } : {},
                    ...this.includeExternalCollaborators ? {
                        productAttributes: {
                            isEntitledConfluenceExternalCollaborator: true
                        }
                    } : {}
                },
                searchQuery: {
                    queryString: query,
                    ...this.includeExternalCollaborators ? {
                        productAccessPermissionIds: [
                            'write',
                            'external-collaborator-write'
                        ]
                    } : {}
                },
                maxNumberOfResults: $76cb501321125a14$var$MAX_RESULTS,
                includeTeams: true
            })
        });
    }
    async searchXproductUsers(cloudId, orgId, query, contextIdentifier) {
        return await (0, $f7B1p.cfetch)(this.userTeamEndpoint, {
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify({
                context: {
                    contextType: $76cb501321125a14$var$CONTEXT_TYPE,
                    principalId: 'context',
                    productKey: 'jira',
                    // fetch only jira users
                    siteId: cloudId,
                    mentionsSessionId: contextIdentifier && contextIdentifier.sessionId,
                    ...orgId ? {
                        organizationId: orgId
                    } : {}
                },
                searchQuery: {
                    queryString: query,
                    productAccessPermissionIds: [
                        'write'
                    ]
                },
                maxNumberOfResults: $76cb501321125a14$var$MAX_RESULTS,
                includeTeams: false // Do not include teams
            })
        });
    }
    isAgent(recommended) {
        // Agents are returned as USER entity type with appType 'agent'
        return recommended.entityType === 'USER' && recommended.appType === 'agent';
    }
    convertToAgentMention(recommended) {
        return {
            id: recommended.id,
            name: recommended.name || recommended.nickname || '',
            mentionName: recommended.nickname || '',
            avatarUrl: recommended.avatarUrl,
            accessLevel: recommended.accessLevel,
            userType: 'APP',
            // Mark as app/agent type
            appType: 'agent'
        };
    }
    isUser(recommended) {
        // Regular users have entityType USER but no agent appType
        return recommended.entityType === 'USER' && recommended.appType !== 'agent';
    }
    convertToUserMention(recommended) {
        return {
            id: recommended.id,
            name: recommended.name || recommended.nickname || '',
            mentionName: recommended.nickname || '',
            avatarUrl: recommended.avatarUrl,
            accessLevel: recommended.accessLevel,
            userType: recommended.userType,
            ...recommended?.attributes?.isConfluenceExternalCollaborator ? {
                lozenge: (0, $9fywD.ExternalUserLozengeProps)
            } : {}
        };
    }
    isTeam(recommended) {
        return recommended.entityType === 'TEAM';
    }
    convertToTeamMention(recommended) {
        const { teamLinkResolver: teamLinkResolver } = this.teamMentionConfig;
        let teamLink = '';
        const defaultTeamLink = `${window.location.origin}/people/team/${recommended.id}`;
        if (typeof teamLinkResolver === 'function') teamLink = teamLinkResolver(recommended.id);
        return {
            id: recommended.id,
            name: recommended.displayName,
            mentionName: recommended.displayName,
            avatarUrl: recommended.smallAvatarImageUrl,
            accessLevel: (0, $caelp.UserAccessLevel)[(0, $caelp.UserAccessLevel).CONTAINER],
            userType: (0, $caelp.UserType)[(0, $caelp.UserType).TEAM],
            context: {
                members: recommended.members,
                includesYou: recommended.includesYou,
                memberCount: recommended.memberCount,
                teamLink: teamLink || defaultTeamLink
            }
        };
    }
    constructor(userTeamEndpoint, userMentionConfig, teamMentionConfig, includeExternalCollaborators, isEligibleXProductUserInvite, includeAgents = false){
        super(userMentionConfig);
        this.userTeamEndpoint = void 0;
        this.teamMentionConfig = void 0;
        this.includeExternalCollaborators = void 0;
        this.includeAgents = void 0;
        this.offlineCache = void 0;
        this.isEligibleXProductUserInvite = void 0;
        this.teamMentionConfig = teamMentionConfig;
        this.userTeamEndpoint = userTeamEndpoint;
        this.includeExternalCollaborators = includeExternalCollaborators;
        this.includeAgents = includeAgents;
        this.isEligibleXProductUserInvite = isEligibleXProductUserInvite;
        const cache = (0, $9wGTI.fg)('platform_editor_offline_editing_web_ga_fixes') ? $76cb501321125a14$var$defaultCache : undefined;
        this.offlineCache = (0, $6mKj3.expValEquals)('platform_editor_offline_editing_web', 'isEnabled', true) ? new (0, $j5rtD.OfflineCache)(cache) : undefined;
    }
}
module.exports["UserTeamMentionProvider"] = $76cb501321125a14$export$f500b4849378edff;

});

parcelRegister("bijHC", function(module, exports) {
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $55fM8 = parcelRequire("55fM8");


var $gABt9 = parcelRequire("gABt9");


var $dJKHF = parcelRequire("dJKHF");


var $jymSm = parcelRequire("jymSm");


var $caelp = parcelRequire("caelp");


var $b3nqj = parcelRequire("b3nqj");


var $2SUNK = parcelRequire("2SUNK");


var $iXlTL = parcelRequire("iXlTL");




const $ec39392517ed4807$var$MAX_QUERY_ITEMS = 100;
const $ec39392517ed4807$var$emptySecurityProvider = ()=>{
    return {
        params: {},
        headers: {}
    };
};
class $ec39392517ed4807$export$5a4331e3e1c43553 extends (0, $iXlTL.AbstractMentionResource) {
    shouldHighlightMention(mention) {
        if (this.config.shouldHighlightMention) return this.config.shouldHighlightMention(mention);
        return false;
    }
    getMentionDisabledState(mention) {
        return this.config.getMentionDisabledState?.(mention);
    }
    notify(searchTime, mentionResult, query) {
        if (searchTime > this.lastReturnedSearch) {
            this.lastReturnedSearch = searchTime;
            this._notifyListeners(mentionResult, {
                duration: Date.now() - searchTime
            });
        } else {
            const date = new Date(searchTime).toISOString().substr(17, 6);
            (0, $2SUNK.default)('Stale search result, skipping', date, query); // eslint-disable-line no-console, max-len
        }
        this._notifyAllResultsListeners(mentionResult);
    }
    notifyError(error, query) {
        this._notifyErrorListeners(error, query);
        if (query) this.activeSearches.delete(query);
    }
    async filter(query, contextIdentifier) {
        try {
            const searchTime = Date.now();
            let results;
            if (!query) results = await this.initialState(contextIdentifier);
            else {
                this.activeSearches.add(query);
                const searchResponse = this.search(query, contextIdentifier);
                results = await searchResponse.mentions;
            }
            this.notify(searchTime, results, query);
        } catch (error) {
            this.notifyError(error, query);
        }
    }
    isFiltering(query) {
        return this.activeSearches.has(query);
    }
    resolveMentionName(id) {
        if (!this.config.mentionNameResolver) return {
            id: id,
            name: '',
            status: (0, $caelp.MentionNameStatus).UNKNOWN
        };
        return this.config.mentionNameResolver.lookupName(id);
    }
    cacheMentionName(id, mentionName) {
        if (!this.config.mentionNameResolver) return;
        this.config.mentionNameResolver.cacheName(id, mentionName);
    }
    supportsMentionNameResolving() {
        return !!this.config.mentionNameResolver;
    }
    updateActiveSearches(query) {
        this.activeSearches.add(query);
    }
    verifyMentionConfig(config) {
        if (!config.url) throw new Error('config.url is a required parameter');
        if (!config.securityProvider) config.securityProvider = $ec39392517ed4807$var$emptySecurityProvider;
    }
    initialState(contextIdentifier) {
        return this.remoteInitialState(contextIdentifier);
    }
    /**
   * Clear a context object to generate query params by removing empty
   * strings, `undefined` and empty values.
   *
   * @param contextIdentifier the current context identifier
   * @returns a safe context for query encoding
   */ clearContext(contextIdentifier = {}) {
        return Object.keys(contextIdentifier).filter((key)=>contextIdentifier[key]).reduce((context, key)=>({
                [key]: contextIdentifier[key],
                ...context
            }), {});
    }
    getQueryParams(contextIdentifier) {
        const configParams = {};
        if (this.config.containerId) configParams['containerId'] = this.config.containerId;
        if (this.config.productId) configParams['productIdentifier'] = this.config.productId;
        // if contextParams exist then it will override configParams for containerId
        return {
            ...configParams,
            ...this.clearContext(contextIdentifier)
        };
    }
    /**
   * Returns the initial mention display list before a search is performed for the specified
   * container.
   *
   * @param contextIdentifier
   * @returns Promise
   */ async remoteInitialState(contextIdentifier) {
        const queryParams = this.getQueryParams(contextIdentifier);
        const configHeaders = this.config.headers;
        const options = {
            path: 'bootstrap',
            queryParams: queryParams,
            ...configHeaders && {
                requestInit: {
                    headers: configHeaders
                }
            }
        };
        try {
            const result = await (0, $gABt9.utils).requestService(this.config, options);
            this._notifyAnalyticsListeners((0, $b3nqj.SLI_EVENT_TYPE), (0, $caelp.SliNames).INITIAL_STATE, (0, $caelp.Actions).SUCCEEDED);
            return this.transformServiceResponse(result, '');
        } catch (error) {
            this._notifyAnalyticsListeners((0, $b3nqj.SLI_EVENT_TYPE), (0, $caelp.SliNames).INITIAL_STATE, (0, $caelp.Actions).FAILED);
            throw error;
        }
    }
    search(query, contextIdentifier) {
        return {
            mentions: this.remoteSearch(query, contextIdentifier)
        };
    }
    async remoteSearch(query, contextIdentifier) {
        const configHeaders = this.config.headers;
        const options = {
            path: 'search',
            queryParams: {
                query: query,
                limit: $ec39392517ed4807$var$MAX_QUERY_ITEMS,
                ...this.getQueryParams(contextIdentifier)
            },
            ...configHeaders && {
                requestInit: {
                    headers: configHeaders
                }
            }
        };
        try {
            const result = await (0, $gABt9.utils).requestService(this.config, options);
            this._notifyAnalyticsListeners((0, $b3nqj.SLI_EVENT_TYPE), (0, $caelp.SliNames).SEARCH, (0, $caelp.Actions).SUCCEEDED);
            return this.transformServiceResponse(result, query);
        } catch (error) {
            this._notifyAnalyticsListeners((0, $b3nqj.SLI_EVENT_TYPE), (0, $caelp.SliNames).SEARCH, (0, $caelp.Actions).FAILED);
            throw error;
        }
    }
    transformServiceResponse(result, query) {
        const mentions = result.mentions.map((mention)=>{
            // Loading placeholders carry none of these fields and pass through untouched.
            if (mention.isPlaceholder) return mention;
            let lozenge;
            if ((0, $dJKHF.isAppMention)(mention)) lozenge = mention.userType;
            else if ((0, $jymSm.isTeamMention)(mention)) lozenge = mention.userType;
            return {
                ...mention,
                lozenge: lozenge,
                query: query
            };
        });
        return {
            ...result,
            mentions: mentions,
            query: result.query || query
        };
    }
    constructor(config){
        super();
        this.config = void 0;
        this.lastReturnedSearch = void 0;
        this.activeSearches = void 0;
        this.productName = void 0;
        this.shouldEnableInvite = void 0;
        this.userRole = void 0;
        this.onInviteItemClick = void 0;
        this.inviteXProductUser = void 0;
        this.verifyMentionConfig(config);
        this.config = config;
        this.lastReturnedSearch = 0;
        this.activeSearches = new Set();
        this.productName = config.productName;
        this.shouldEnableInvite = !!config.shouldEnableInvite;
        this.onInviteItemClick = config.onInviteItemClick;
        this.inviteXProductUser = config.inviteXProductUser;
        this.userRole = config.userRole || 'basic';
        if (this.config.debounceTime) this.filter = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(this.filter, this.config.debounceTime);
    }
}
var $ec39392517ed4807$export$2e2bcd8739ae039 = $ec39392517ed4807$export$5a4331e3e1c43553;
module.exports["MentionResource"] = $ec39392517ed4807$export$5a4331e3e1c43553;

});

parcelRegister("dJKHF", function(module, exports) {

var $caelp = parcelRequire("caelp");

function $c171ae8007140e98$export$eb590c844d13454c(mention) {
    return mention.userType && mention.userType === (0, $caelp.UserType)[(0, $caelp.UserType).APP];
}
module.exports["isAppMention"] = $c171ae8007140e98$export$eb590c844d13454c;

});

parcelRegister("b3nqj", function(module, exports) {
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 







const $39262f9932c4c2bd$export$245097525aef1262 = 'sli';
const $39262f9932c4c2bd$export$c724588856bbfbcf = 'smart';
const $39262f9932c4c2bd$export$990f5c29478a61aa = 'atlassian.fabric.mention';
module.exports["SLI_EVENT_TYPE"] = $39262f9932c4c2bd$export$245097525aef1262;
module.exports["SMART_EVENT_TYPE"] = $39262f9932c4c2bd$export$c724588856bbfbcf;

});

parcelRegister("iXlTL", function(module, exports) {

var $2SUNK = parcelRequire("2SUNK");


var $dvMxu = parcelRequire("dvMxu");

const $f6b0f26d443249fd$var$MAX_NOTIFIED_ITEMS = 20;
class $f6b0f26d443249fd$export$8576ba1ed2760927 extends (0, $dvMxu.AbstractResource) {
    shouldHighlightMention(_mention) {
        return false;
    }
    // eslint-disable-next-line class-methods-use-this
    filter(query) {
        throw new Error(`not yet implemented.\nParams: query=${query}`);
    }
    // eslint-disable-next-line class-methods-use-this, no-unused-vars
    recordMentionSelection(_mention) {
    // Do nothing
    }
    isFiltering(_query) {
        return false;
    }
    _notifyListeners(mentionsResult, stats) {
        (0, $2SUNK.default)('ak-mention-resource._notifyListeners', mentionsResult && mentionsResult.mentions && mentionsResult.mentions.length, this.changeListeners);
        this.changeListeners.forEach((listener, key)=>{
            try {
                listener(mentionsResult.mentions.slice(0, $f6b0f26d443249fd$var$MAX_NOTIFIED_ITEMS), mentionsResult.query, stats);
            } catch (e) {
                // ignore error from listener
                (0, $2SUNK.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyAllResultsListeners(mentionsResult) {
        (0, $2SUNK.default)('ak-mention-resource._notifyAllResultsListeners', mentionsResult && mentionsResult.mentions && mentionsResult.mentions.length, this.changeListeners);
        this.allResultsListeners.forEach((listener, key)=>{
            try {
                listener(mentionsResult.mentions.slice(0, $f6b0f26d443249fd$var$MAX_NOTIFIED_ITEMS), mentionsResult.query);
            } catch (e) {
                // ignore error from listener
                (0, $2SUNK.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyErrorListeners(error, query) {
        this.errListeners.forEach((listener, key)=>{
            try {
                listener(error, query);
            } catch (e) {
                // ignore error from listener
                (0, $2SUNK.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyInfoListeners(info) {
        this.infoListeners.forEach((listener, key)=>{
            try {
                listener(info);
            } catch (e) {
                // ignore error fromr listener
                (0, $2SUNK.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyAnalyticsListeners(event, actionSubject, action, attributes) {
        this.analyticsListeners.forEach((listener, key)=>{
            try {
                listener(event, actionSubject, action, attributes);
            } catch (e) {
                // ignore error from listener
                (0, $2SUNK.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
}
module.exports["AbstractMentionResource"] = $f6b0f26d443249fd$export$8576ba1ed2760927;

});

parcelRegister("5CrKL", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $fd6g2 = parcelRequire("fd6g2");

const $41760797bb45431a$export$59eae628ebf25df4 = (0, $lSOAM.createCustomMetric)({
    key: (0, $fd6g2.MENTIONS_QUERY_CUSTOM_KEY)
});
module.exports["MENTIONS_QUERY_METRIC"] = $41760797bb45431a$export$59eae628ebf25df4;

});

parcelRegister("j5rtD", function(module, exports) {

var $cbY7C = parcelRequire("cbY7C");

class $099b8337f3ad112c$export$8904fcd398c673fb {
    update() {
        this.storageManager.setStoredValues(this.map).catch(()=>{
        // Pass, it's okay if this fails
        });
    }
    destroy() {
        this.unloadCleanup();
    }
    get(key) {
        return this.map.get(key);
    }
    set(key, value) {
        this.map.set(key, value);
    }
    constructor(storageManager){
        this.map = new Map();
        this.storageManager = void 0;
        this.unloadCleanup = ()=>{};
        const cacheName = 'editor:offline-network-request-cache';
        this.storageManager = storageManager ?? new $099b8337f3ad112c$var$IndexedDBManager(cacheName);
        this.storageManager.getStoredValues()?.then((v)=>{
            this.map = v;
        }).catch(()=>{
        // If the offline cache is rejected, use the initial empty map
        });
        if (window !== undefined) this.unloadCleanup = (0, $cbY7C.bind)(window, {
            type: 'beforeunload',
            listener: ()=>{
                this.update();
            }
        });
    }
}
/** Storage manager using indexeddb */ class $099b8337f3ad112c$var$IndexedDBManager {
    openDatabase() {
        return new Promise((resolve, reject)=>{
            const request = indexedDB.open(this.cacheName, 2);
            request.onupgradeneeded = (event)=>{
                const db = event.target.result;
                // Clear old results
                if (db.objectStoreNames.contains(this.objectStoreName)) db.deleteObjectStore(this.objectStoreName);
                db.createObjectStore(this.objectStoreName);
            };
            request.onsuccess = ()=>{
                resolve(request.result);
            };
            request.onerror = ()=>{
                reject(request.error);
            };
        });
    }
    // Retrieve a map of values for a store based on a set of keys
    async getAllStoredValues(store, keys) {
        const allValues = [];
        for (const key of keys){
            const valueRequest = store.get(key);
            allValues.push(new Promise((resolve, reject)=>{
                valueRequest.onsuccess = ()=>resolve([
                        key,
                        JSON.parse(valueRequest.result)
                    ]);
                valueRequest.onerror = ()=>reject(valueRequest.error);
            }));
        }
        return new Map(await Promise.all(allValues));
    }
    getStoredValues() {
        return this.dbPromise?.then((db)=>{
            return new Promise((resolve, reject)=>{
                const transaction = db.transaction(this.objectStoreName, 'readonly');
                const store = transaction.objectStore(this.objectStoreName);
                const request = store.getAllKeys();
                request.onsuccess = async ()=>{
                    const keys = request.result;
                    const resultMap = await this.getAllStoredValues(store, keys);
                    resolve(resultMap);
                };
                request.onerror = ()=>{
                    reject(request.error);
                };
            });
        }) ?? Promise.reject();
    }
    setStoredValues(values) {
        return this.dbPromise?.then((db)=>{
            return new Promise((resolve, reject)=>{
                const transaction = db.transaction(this.objectStoreName, 'readwrite');
                const store = transaction.objectStore(this.objectStoreName);
                transaction.oncomplete = ()=>resolve();
                transaction.onerror = ()=>reject(transaction.error);
                if (values.size === 0) return;
                // Clear the existing entries before setting new values
                store.clear().onsuccess = ()=>{
                    values.forEach((value, key)=>{
                        const serialisedValue = $099b8337f3ad112c$export$ad730aacbc246ec2(value);
                        if (serialisedValue !== null) store.put(serialisedValue, key);
                    });
                };
            });
        }) ?? Promise.reject();
    }
    constructor(cacheName){
        this.cacheName = cacheName;
        this.dbPromise = undefined;
        this.objectStoreName = 'cache';
        if (window?.indexedDB) this.dbPromise = this.openDatabase();
    }
}
function $099b8337f3ad112c$export$ad730aacbc246ec2(obj) {
    try {
        return JSON.stringify(obj, (_key, value)=>{
            if (typeof value !== 'string' && typeof value !== 'number' && typeof value !== 'boolean' && value !== null && value !== undefined && typeof value !== 'object' && !Array.isArray(value)) throw new Error('Non-serializable property found');
            return value;
        });
    } catch (error) {
        return null;
    }
}
module.exports["OfflineCache"] = $099b8337f3ad112c$export$8904fcd398c673fb;

});

parcelRegister("gYPwD", function(module, exports) {

var $gNfbp = parcelRequire("gNfbp");


var $eKwxR = parcelRequire("eKwxR");


var $kCDdC = parcelRequire("kCDdC");


var $as9lu = parcelRequire("as9lu");


var $c0rhi = parcelRequire("c0rhi");


var $3IBnw = parcelRequire("3IBnw");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $ge2sX = parcelRequire("ge2sX");

const $5016900c96a66750$var$PRODUCT = 'confluence';
async function $5016900c96a66750$export$edde3720d795ca12(query, maxResults) {
    let mentions;
    try {
        mentions = query ? await $5016900c96a66750$var$queryAgentMentionsByName(query, maxResults) : await $5016900c96a66750$var$queryAgentMentionsForInitialState(maxResults);
    } catch (error) {
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).COMMENTS
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        throw error;
    }
    return {
        query: query,
        mentions: mentions
    };
}
async function $5016900c96a66750$var$queryAgentMentionsByName(query, maxResults) {
    const { cloudId: cloudId } = await (0, $ge2sX.getSessionData)();
    const { data: data, error: error } = await (0, $c0rhi.queryInterop)({
        query: $5016900c96a66750$var$queryAgentMentionsByNameQuery,
        variables: {
            cloudId: cloudId,
            first: maxResults,
            input: {
                name: query
            },
            product: $5016900c96a66750$var$PRODUCT
        },
        interopApolloAggClient: true,
        __callerPackage__: "fabric-media-support"
    });
    if (error) throw error;
    return $5016900c96a66750$var$convertToMentions(data?.agentStudio_getAgents?.edges);
}
async function $5016900c96a66750$var$queryAgentMentionsForInitialState(maxResults) {
    const { cloudId: cloudId } = await (0, $ge2sX.getSessionData)();
    const { data: data, error: error } = await (0, $c0rhi.queryInterop)({
        query: $5016900c96a66750$var$queryAgentMentionsForInitialStateQuery,
        variables: {
            cloudId: cloudId,
            first: maxResults,
            product: $5016900c96a66750$var$PRODUCT
        },
        interopApolloAggClient: true,
        __callerPackage__: "fabric-media-support"
    });
    if (error) throw error;
    const mentions = [
        ...$5016900c96a66750$var$convertToMentions(data?.favoriteAgents?.edges),
        ...$5016900c96a66750$var$convertToMentions(data?.verifiedAgents?.edges),
        ...$5016900c96a66750$var$convertToMentions(data?.allAgents?.edges)
    ];
    // Only return the first distinct maxResults:
    const returnedMentionIds = new Set();
    return mentions.filter((mention)=>{
        if (returnedMentionIds.size >= maxResults || returnedMentionIds.has(mention.id)) return false;
        returnedMentionIds.add(mention.id);
        return true;
    });
}
function $5016900c96a66750$var$convertToMentions(edges) {
    return edges?.map((edge)=>edge.node).filter((agent)=>Boolean(agent?.identityAccountId && agent?.name)).map($5016900c96a66750$var$convertToMentionDescription) ?? [];
}
function $5016900c96a66750$var$convertToMentionDescription(agent) {
    return {
        appType: 'agent',
        avatarUrl: agent.identityAccount?.picture || undefined,
        description: agent.description || undefined,
        id: $5016900c96a66750$export$8cac12d91c2ad785(agent.identityAccountId),
        mentionName: agent.name,
        name: agent.name,
        userType: 'APP'
    };
}
function $5016900c96a66750$export$8cac12d91c2ad785(identityAccountId) {
    try {
        return (0, $as9lu.IdentityUserAri).parse(identityAccountId).userId;
    } catch  {
        return identityAccountId;
    }
}
const $5016900c96a66750$export$ee0ef79a58e4aab4 = (0, $kCDdC.default);
const $5016900c96a66750$var$queryAgentMentionsByNameQuery = (0, $eKwxR.default);
const $5016900c96a66750$var$queryAgentMentionsForInitialStateQuery = (0, $gNfbp.default);
module.exports["queryAgentMentions"] = $5016900c96a66750$export$edde3720d795ca12;

});

parcelRegister("gNfbp", function(module, exports) {
/**
 * @generated SignedSource<<960b4a6121210e2627708c871388f410>>
 * @relayHash 890e1571ca36f0bf8f139935a1730a9e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5450d7fd881a42d0caeb0d595de491126d1e0737edbbf5f9cc3be37096e809f2
const $23b05ae499fb93a6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "first"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "product"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    }, v3 = {
        "kind": "Variable",
        "name": "product",
        "variableName": "product"
    }, v4 = [
        v1 /*: any*/ ,
        v2 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "input",
            "value": {
                "onlyFavouriteAgents": true
            }
        },
        v3 /*: any*/ 
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "description"
    }, v7 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v8 = {
        "kind": "ScalarField",
        "name": "identityAccountId"
    }, v9 = {
        "kind": "ScalarField",
        "name": "name"
    }, v10 = [
        {
            "concreteType": "AgentStudioAgentEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "AgentStudioAssistant",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "identityAccount",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ 
                            ]
                        },
                        v8 /*: any*/ ,
                        v9 /*: any*/ 
                    ]
                }
            ]
        }
    ], v11 = [
        v1 /*: any*/ ,
        v2 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "input",
            "value": {
                "onlyVerifiedAgents": true
            }
        },
        v3 /*: any*/ 
    ], v12 = [
        v1 /*: any*/ ,
        v2 /*: any*/ ,
        v3 /*: any*/ 
    ], v13 = [
        {
            "concreteType": "AgentStudioAgentEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "AgentStudioAssistant",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "identityAccount",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                v7 /*: any*/ ,
                                v5 /*: any*/ 
                            ]
                        },
                        v8 /*: any*/ ,
                        v9 /*: any*/ 
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "queryAgentMentionsForInitialStateQuery",
            "selections": [
                {
                    "alias": "favoriteAgents",
                    "args": v4 /*: any*/ ,
                    "concreteType": "AgentStudioAgentsConnection",
                    "kind": "LinkedField",
                    "name": "agentStudio_getAgents",
                    "plural": false,
                    "selections": v10 /*: any*/ 
                },
                {
                    "alias": "verifiedAgents",
                    "args": v11 /*: any*/ ,
                    "concreteType": "AgentStudioAgentsConnection",
                    "kind": "LinkedField",
                    "name": "agentStudio_getAgents",
                    "plural": false,
                    "selections": v10 /*: any*/ 
                },
                {
                    "alias": "allAgents",
                    "args": v12 /*: any*/ ,
                    "concreteType": "AgentStudioAgentsConnection",
                    "kind": "LinkedField",
                    "name": "agentStudio_getAgents",
                    "plural": false,
                    "selections": v10 /*: any*/ 
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "queryAgentMentionsForInitialStateQuery",
            "selections": [
                {
                    "alias": "favoriteAgents",
                    "args": v4 /*: any*/ ,
                    "concreteType": "AgentStudioAgentsConnection",
                    "kind": "LinkedField",
                    "name": "agentStudio_getAgents",
                    "plural": false,
                    "selections": v13 /*: any*/ 
                },
                {
                    "alias": "verifiedAgents",
                    "args": v11 /*: any*/ ,
                    "concreteType": "AgentStudioAgentsConnection",
                    "kind": "LinkedField",
                    "name": "agentStudio_getAgents",
                    "plural": false,
                    "selections": v13 /*: any*/ 
                },
                {
                    "alias": "allAgents",
                    "args": v12 /*: any*/ ,
                    "concreteType": "AgentStudioAgentsConnection",
                    "kind": "LinkedField",
                    "name": "agentStudio_getAgents",
                    "plural": false,
                    "selections": v13 /*: any*/ 
                }
            ]
        },
        "params": {
            "cacheID": "890e1571ca36f0bf8f139935a1730a9e",
            "id": "5450d7fd881a42d0caeb0d595de491126d1e0737edbbf5f9cc3be37096e809f2",
            "metadata": {},
            "name": "queryAgentMentionsForInitialStateQuery",
            "operationKind": "query",
            "text": "query queryAgentMentionsForInitialStateQuery($cloudId:String!,$first:Int,$product:String){favoriteAgents:agentStudio_getAgents(cloudId:$cloudId,first:$first,input:{onlyFavouriteAgents:true},product:$product)@optIn(to:\"AgentStudio\"){edges{node{id,description,identityAccount{__typename,picture,id},identityAccountId,name}}},verifiedAgents:agentStudio_getAgents(cloudId:$cloudId,first:$first,input:{onlyVerifiedAgents:true},product:$product)@optIn(to:\"AgentStudio\"){edges{node{id,description,identityAccount{__typename,picture,id},identityAccountId,name}}},allAgents:agentStudio_getAgents(cloudId:$cloudId,first:$first,product:$product)@optIn(to:\"AgentStudio\"){edges{node{id,description,identityAccount{__typename,picture,id},identityAccountId,name}}}}"
        }
    };
}();
$23b05ae499fb93a6$var$node.hash = "7b8fc7e0377ddfa0fae702a19385c8e8";
var $23b05ae499fb93a6$export$2e2bcd8739ae039 = $23b05ae499fb93a6$var$node;
module.exports["default"] = $23b05ae499fb93a6$export$2e2bcd8739ae039;

});

parcelRegister("eKwxR", function(module, exports) {
/**
 * @generated SignedSource<<4a83e169362370dead5932328f8e400e>>
 * @relayHash eb2b45b6f1c6a0bf9f3f42710420bd9e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3bfb66bc29f1d4ba518f3f90ceb733bbc250f8984683a642222fe65ede346b9c
const $d9f9c84cb1e3d64f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "first"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "product"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        },
        {
            "kind": "Variable",
            "name": "product",
            "variableName": "product"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "description"
    }, v4 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v5 = {
        "kind": "ScalarField",
        "name": "identityAccountId"
    }, v6 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "queryAgentMentionsByNameQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "AgentStudioAgentsConnection",
                    "kind": "LinkedField",
                    "name": "agentStudio_getAgents",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "AgentStudioAgentEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "AgentStudioAssistant",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "identityAccount",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ 
                                            ]
                                        },
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "queryAgentMentionsByNameQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "AgentStudioAgentsConnection",
                    "kind": "LinkedField",
                    "name": "agentStudio_getAgents",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "AgentStudioAgentEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "AgentStudioAssistant",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "identityAccount",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v4 /*: any*/ ,
                                                v2 /*: any*/ 
                                            ]
                                        },
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "eb2b45b6f1c6a0bf9f3f42710420bd9e",
            "id": "3bfb66bc29f1d4ba518f3f90ceb733bbc250f8984683a642222fe65ede346b9c",
            "metadata": {},
            "name": "queryAgentMentionsByNameQuery",
            "operationKind": "query",
            "text": "query queryAgentMentionsByNameQuery($cloudId:String!,$first:Int,$input:AgentStudioAgentQueryInput,$product:String){agentStudio_getAgents(cloudId:$cloudId,first:$first,input:$input,product:$product)@optIn(to:\"AgentStudio\"){edges{node{id,description,identityAccount{__typename,picture,id},identityAccountId,name}}}}"
        }
    };
}();
$d9f9c84cb1e3d64f$var$node.hash = "f44bfcd4dfdb02102d0d5899552fd79b";
var $d9f9c84cb1e3d64f$export$2e2bcd8739ae039 = $d9f9c84cb1e3d64f$var$node;
module.exports["default"] = $d9f9c84cb1e3d64f$export$2e2bcd8739ae039;

});

parcelRegister("kCDdC", function(module, exports) {
/**
 * @generated SignedSource<<5e3744baa56592241aa8051b0c2ab009>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5c4367f6180fde75$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "queryAgentMentionsFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "description"
        },
        {
            "kind": "LinkedField",
            "name": "identityAccount",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "picture"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "identityAccountId"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        }
    ],
    "type": "AgentStudioAssistant"
};
$5c4367f6180fde75$var$node.hash = "c9fe20126b9ae533caed55eab71ee09d";
var $5c4367f6180fde75$export$2e2bcd8739ae039 = $5c4367f6180fde75$var$node;
module.exports["default"] = $5c4367f6180fde75$export$2e2bcd8739ae039;

});

parcelRegister("g2yI6", function(module, exports) {

var $89CKS = parcelRequire("89CKS");


var $c0rhi = parcelRequire("c0rhi");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");

const $28b5c5efee4d19cf$var$fetchMentionsProviderDataQuery = (0, $89CKS.default);
const $28b5c5efee4d19cf$export$5ced7267a5286f97 = async ()=>{
    return (0, $c0rhi.queryInterop)({
        query: $28b5c5efee4d19cf$var$fetchMentionsProviderDataQuery,
        __callerPackage__: "fabric-media-support"
    }).then(({ data: data })=>{
        return data;
    }).catch((error)=>{
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        return undefined;
    });
};
module.exports["fetchMentionsProviderData"] = $28b5c5efee4d19cf$export$5ced7267a5286f97;

});

parcelRegister("13PMQ", function(module, exports) {
// DEFLATE is a complex format; to read this code, you should probably check the RFC first:
// https://tools.ietf.org/html/rfc1951
// You may also wish to take a look at the guide I made about this program:
// https://gist.github.com/101arrowz/253f31eb5abc3d9275ab943003ffecad
// Some of the following code is similar to that of UZIP.js:
// https://github.com/photopea/UZIP.js
// However, the vast majority of the codebase has diverged from UZIP.js to increase performance and reduce bundle size.
// Sometimes 0 will appear where -1 would be more appropriate. This is because using a uint
// is better for memory in most engines (I *think*).
var $0c5e3e04f495ba65$var$ch2 = {};
var $0c5e3e04f495ba65$var$wk = function(c, id, msg, transfer, cb) {
    var w = new Worker($0c5e3e04f495ba65$var$ch2[id] || ($0c5e3e04f495ba65$var$ch2[id] = URL.createObjectURL(new Blob([
        c + ';addEventListener("error",function(e){e=e.error;postMessage({$e$:[e.message,e.code,e.stack]})})'
    ], {
        type: 'text/javascript'
    }))));
    w.onmessage = function(e) {
        var d = e.data, ed = d.$e$;
        if (ed) {
            var err = new Error(ed[0]);
            err['code'] = ed[1];
            err.stack = ed[2];
            cb(err, null);
        } else cb(null, d);
    };
    w.postMessage(msg, transfer);
    return w;
};
// aliases for shorter compressed code (most minifers don't do this)
var $0c5e3e04f495ba65$var$u8 = Uint8Array, $0c5e3e04f495ba65$var$u16 = Uint16Array, $0c5e3e04f495ba65$var$i32 = Int32Array;
// fixed length extra bits
var $0c5e3e04f495ba65$var$fleb = new $0c5e3e04f495ba65$var$u8([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0,
    /* unused */ 0,
    0,
    /* impossible */ 0
]);
// fixed distance extra bits
var $0c5e3e04f495ba65$var$fdeb = new $0c5e3e04f495ba65$var$u8([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13,
    /* unused */ 0,
    0
]);
// code length index map
var $0c5e3e04f495ba65$var$clim = new $0c5e3e04f495ba65$var$u8([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
// get base, reverse index map from extra bits
var $0c5e3e04f495ba65$var$freb = function(eb, start) {
    var b = new $0c5e3e04f495ba65$var$u16(31);
    for(var i = 0; i < 31; ++i)b[i] = start += 1 << eb[i - 1];
    // numbers here are at max 18 bits
    var r = new $0c5e3e04f495ba65$var$i32(b[30]);
    for(var i = 1; i < 30; ++i)for(var j = b[i]; j < b[i + 1]; ++j)r[j] = j - b[i] << 5 | i;
    return {
        b: b,
        r: r
    };
};
var $0c5e3e04f495ba65$var$_a = $0c5e3e04f495ba65$var$freb($0c5e3e04f495ba65$var$fleb, 2), $0c5e3e04f495ba65$var$fl = $0c5e3e04f495ba65$var$_a.b, $0c5e3e04f495ba65$var$revfl = $0c5e3e04f495ba65$var$_a.r;
// we can ignore the fact that the other numbers are wrong; they never happen anyway
$0c5e3e04f495ba65$var$fl[28] = 258, $0c5e3e04f495ba65$var$revfl[258] = 28;
var $0c5e3e04f495ba65$var$_b = $0c5e3e04f495ba65$var$freb($0c5e3e04f495ba65$var$fdeb, 0), $0c5e3e04f495ba65$var$fd = $0c5e3e04f495ba65$var$_b.b, $0c5e3e04f495ba65$var$revfd = $0c5e3e04f495ba65$var$_b.r;
// map of value to reverse (assuming 16 bits)
var $0c5e3e04f495ba65$var$rev = new $0c5e3e04f495ba65$var$u16(32768);
for(var $0c5e3e04f495ba65$var$i = 0; $0c5e3e04f495ba65$var$i < 32768; ++$0c5e3e04f495ba65$var$i){
    // reverse table algorithm from SO
    var $0c5e3e04f495ba65$var$x = ($0c5e3e04f495ba65$var$i & 0xAAAA) >> 1 | ($0c5e3e04f495ba65$var$i & 0x5555) << 1;
    $0c5e3e04f495ba65$var$x = ($0c5e3e04f495ba65$var$x & 0xCCCC) >> 2 | ($0c5e3e04f495ba65$var$x & 0x3333) << 2;
    $0c5e3e04f495ba65$var$x = ($0c5e3e04f495ba65$var$x & 0xF0F0) >> 4 | ($0c5e3e04f495ba65$var$x & 0x0F0F) << 4;
    $0c5e3e04f495ba65$var$rev[$0c5e3e04f495ba65$var$i] = (($0c5e3e04f495ba65$var$x & 0xFF00) >> 8 | ($0c5e3e04f495ba65$var$x & 0x00FF) << 8) >> 1;
}
// create huffman tree from u8 "map": index -> code length for code index
// mb (max bits) must be at most 15
// TODO: optimize/split up?
var $0c5e3e04f495ba65$var$hMap = function(cd, mb, r) {
    var s = cd.length;
    // index
    var i = 0;
    // u16 "map": index -> # of codes with bit length = index
    var l = new $0c5e3e04f495ba65$var$u16(mb);
    // length of cd must be 288 (total # of codes)
    for(; i < s; ++i)if (cd[i]) ++l[cd[i] - 1];
    // u16 "map": index -> minimum code for bit length = index
    var le = new $0c5e3e04f495ba65$var$u16(mb);
    for(i = 1; i < mb; ++i)le[i] = le[i - 1] + l[i - 1] << 1;
    var co;
    if (r) {
        // u16 "map": index -> number of actual bits, symbol for code
        co = new $0c5e3e04f495ba65$var$u16(1 << mb);
        // bits to remove for reverser
        var rvb = 15 - mb;
        for(i = 0; i < s; ++i)// ignore 0 lengths
        if (cd[i]) {
            // num encoding both symbol and bits read
            var sv = i << 4 | cd[i];
            // free bits
            var r_1 = mb - cd[i];
            // start value
            var v = le[cd[i] - 1]++ << r_1;
            // m is end value
            for(var m = v | (1 << r_1) - 1; v <= m; ++v)// every 16 bit value starting with the code yields the same result
            co[$0c5e3e04f495ba65$var$rev[v] >> rvb] = sv;
        }
    } else {
        co = new $0c5e3e04f495ba65$var$u16(s);
        for(i = 0; i < s; ++i)if (cd[i]) co[i] = $0c5e3e04f495ba65$var$rev[le[cd[i] - 1]++] >> 15 - cd[i];
    }
    return co;
};
// fixed length tree
var $0c5e3e04f495ba65$var$flt = new $0c5e3e04f495ba65$var$u8(288);
for(var $0c5e3e04f495ba65$var$i = 0; $0c5e3e04f495ba65$var$i < 144; ++$0c5e3e04f495ba65$var$i)$0c5e3e04f495ba65$var$flt[$0c5e3e04f495ba65$var$i] = 8;
for(var $0c5e3e04f495ba65$var$i = 144; $0c5e3e04f495ba65$var$i < 256; ++$0c5e3e04f495ba65$var$i)$0c5e3e04f495ba65$var$flt[$0c5e3e04f495ba65$var$i] = 9;
for(var $0c5e3e04f495ba65$var$i = 256; $0c5e3e04f495ba65$var$i < 280; ++$0c5e3e04f495ba65$var$i)$0c5e3e04f495ba65$var$flt[$0c5e3e04f495ba65$var$i] = 7;
for(var $0c5e3e04f495ba65$var$i = 280; $0c5e3e04f495ba65$var$i < 288; ++$0c5e3e04f495ba65$var$i)$0c5e3e04f495ba65$var$flt[$0c5e3e04f495ba65$var$i] = 8;
// fixed distance tree
var $0c5e3e04f495ba65$var$fdt = new $0c5e3e04f495ba65$var$u8(32);
for(var $0c5e3e04f495ba65$var$i = 0; $0c5e3e04f495ba65$var$i < 32; ++$0c5e3e04f495ba65$var$i)$0c5e3e04f495ba65$var$fdt[$0c5e3e04f495ba65$var$i] = 5;
// fixed length map
var $0c5e3e04f495ba65$var$flm = /*#__PURE__*/ $0c5e3e04f495ba65$var$hMap($0c5e3e04f495ba65$var$flt, 9, 0), $0c5e3e04f495ba65$var$flrm = /*#__PURE__*/ $0c5e3e04f495ba65$var$hMap($0c5e3e04f495ba65$var$flt, 9, 1);
// fixed distance map
var $0c5e3e04f495ba65$var$fdm = /*#__PURE__*/ $0c5e3e04f495ba65$var$hMap($0c5e3e04f495ba65$var$fdt, 5, 0), $0c5e3e04f495ba65$var$fdrm = /*#__PURE__*/ $0c5e3e04f495ba65$var$hMap($0c5e3e04f495ba65$var$fdt, 5, 1);
// find max of array
var $0c5e3e04f495ba65$var$max = function(a) {
    var m = a[0];
    for(var i = 1; i < a.length; ++i)if (a[i] > m) m = a[i];
    return m;
};
// read d, starting at bit p and mask with m
var $0c5e3e04f495ba65$var$bits = function(d, p, m) {
    var o = p / 8 | 0;
    return (d[o] | d[o + 1] << 8) >> (p & 7) & m;
};
// read d, starting at bit p continuing for at least 16 bits
var $0c5e3e04f495ba65$var$bits16 = function(d, p) {
    var o = p / 8 | 0;
    return (d[o] | d[o + 1] << 8 | d[o + 2] << 16) >> (p & 7);
};
// get end of byte
var $0c5e3e04f495ba65$var$shft = function(p) {
    return (p + 7) / 8 | 0;
};
// typed array slice - allows garbage collector to free original reference,
// while being more compatible than .slice
var $0c5e3e04f495ba65$var$slc = function(v, s, e) {
    if (s == null || s < 0) s = 0;
    if (e == null || e > v.length) e = v.length;
    // can't use .constructor in case user-supplied
    return new $0c5e3e04f495ba65$var$u8(v.subarray(s, e));
};
var $0c5e3e04f495ba65$export$ae5516a5a74c19a8 = {
    UnexpectedEOF: 0,
    InvalidBlockType: 1,
    InvalidLengthLiteral: 2,
    InvalidDistance: 3,
    StreamFinished: 4,
    NoStreamHandler: 5,
    InvalidHeader: 6,
    NoCallback: 7,
    InvalidUTF8: 8,
    ExtraFieldTooLong: 9,
    InvalidDate: 10,
    FilenameTooLong: 11,
    StreamFinishing: 12,
    InvalidZipData: 13,
    UnknownCompressionMethod: 14
};
// error codes
var $0c5e3e04f495ba65$var$ec = [
    'unexpected EOF',
    'invalid block type',
    'invalid length/literal',
    'invalid distance',
    'stream finished',
    'no stream handler',
    ,
    'no callback',
    'invalid UTF-8 data',
    'extra field too long',
    'date not in range 1980-2099',
    'filename too long',
    'stream finishing',
    'invalid zip data'
];
var $0c5e3e04f495ba65$var$err = function(ind, msg, nt) {
    var e = new Error(msg || $0c5e3e04f495ba65$var$ec[ind]);
    e.code = ind;
    if (Error.captureStackTrace) Error.captureStackTrace(e, $0c5e3e04f495ba65$var$err);
    if (!nt) throw e;
    return e;
};
// expands raw DEFLATE data
var $0c5e3e04f495ba65$var$inflt = function(dat, st, buf, dict) {
    // source length       dict length
    var sl = dat.length, dl = dict ? dict.length : 0;
    if (!sl || st.f && !st.l) return buf || new $0c5e3e04f495ba65$var$u8(0);
    var noBuf = !buf;
    // have to estimate size
    var resize = noBuf || st.i != 2;
    // no state
    var noSt = st.i;
    // Assumes roughly 33% compression ratio average
    if (noBuf) buf = new $0c5e3e04f495ba65$var$u8(sl * 3);
    // ensure buffer can fit at least l elements
    var cbuf = function(l) {
        var bl = buf.length;
        // need to increase size to fit
        if (l > bl) {
            // Double or set to necessary, whichever is greater
            var nbuf = new $0c5e3e04f495ba65$var$u8(Math.max(bl * 2, l));
            nbuf.set(buf);
            buf = nbuf;
        }
    };
    //  last chunk         bitpos           bytes
    var final = st.f || 0, pos = st.p || 0, bt = st.b || 0, lm = st.l, dm = st.d, lbt = st.m, dbt = st.n;
    // total bits
    var tbts = sl * 8;
    do {
        if (!lm) {
            // BFINAL - this is only 1 when last chunk is next
            final = $0c5e3e04f495ba65$var$bits(dat, pos, 1);
            // type: 0 = no compression, 1 = fixed huffman, 2 = dynamic huffman
            var type = $0c5e3e04f495ba65$var$bits(dat, pos + 1, 3);
            pos += 3;
            if (!type) {
                // go to end of byte boundary
                var s = $0c5e3e04f495ba65$var$shft(pos) + 4, l = dat[s - 4] | dat[s - 3] << 8, t = s + l;
                if (t > sl) {
                    if (noSt) $0c5e3e04f495ba65$var$err(0);
                    break;
                }
                // ensure size
                if (resize) cbuf(bt + l);
                // Copy over uncompressed data
                buf.set(dat.subarray(s, t), bt);
                // Get new bitpos, update byte count
                st.b = bt += l, st.p = pos = t * 8, st.f = final;
                continue;
            } else if (type == 1) lm = $0c5e3e04f495ba65$var$flrm, dm = $0c5e3e04f495ba65$var$fdrm, lbt = 9, dbt = 5;
            else if (type == 2) {
                //  literal                            lengths
                var hLit = $0c5e3e04f495ba65$var$bits(dat, pos, 31) + 257, hcLen = $0c5e3e04f495ba65$var$bits(dat, pos + 10, 15) + 4;
                var tl = hLit + $0c5e3e04f495ba65$var$bits(dat, pos + 5, 31) + 1;
                pos += 14;
                // length+distance tree
                var ldt = new $0c5e3e04f495ba65$var$u8(tl);
                // code length tree
                var clt = new $0c5e3e04f495ba65$var$u8(19);
                for(var i = 0; i < hcLen; ++i)// use index map to get real code
                clt[$0c5e3e04f495ba65$var$clim[i]] = $0c5e3e04f495ba65$var$bits(dat, pos + i * 3, 7);
                pos += hcLen * 3;
                // code lengths bits
                var clb = $0c5e3e04f495ba65$var$max(clt), clbmsk = (1 << clb) - 1;
                // code lengths map
                var clm = $0c5e3e04f495ba65$var$hMap(clt, clb, 1);
                for(var i = 0; i < tl;){
                    var r = clm[$0c5e3e04f495ba65$var$bits(dat, pos, clbmsk)];
                    // bits read
                    pos += r & 15;
                    // symbol
                    var s = r >> 4;
                    // code length to copy
                    if (s < 16) ldt[i++] = s;
                    else {
                        //  copy   count
                        var c = 0, n = 0;
                        if (s == 16) n = 3 + $0c5e3e04f495ba65$var$bits(dat, pos, 3), pos += 2, c = ldt[i - 1];
                        else if (s == 17) n = 3 + $0c5e3e04f495ba65$var$bits(dat, pos, 7), pos += 3;
                        else if (s == 18) n = 11 + $0c5e3e04f495ba65$var$bits(dat, pos, 127), pos += 7;
                        while(n--)ldt[i++] = c;
                    }
                }
                //    length tree                 distance tree
                var lt = ldt.subarray(0, hLit), dt = ldt.subarray(hLit);
                // max length bits
                lbt = $0c5e3e04f495ba65$var$max(lt);
                // max dist bits
                dbt = $0c5e3e04f495ba65$var$max(dt);
                lm = $0c5e3e04f495ba65$var$hMap(lt, lbt, 1);
                dm = $0c5e3e04f495ba65$var$hMap(dt, dbt, 1);
            } else $0c5e3e04f495ba65$var$err(1);
            if (pos > tbts) {
                if (noSt) $0c5e3e04f495ba65$var$err(0);
                break;
            }
        }
        // Make sure the buffer can hold this + the largest possible addition
        // Maximum chunk size (practically, theoretically infinite) is 2^17
        if (resize) cbuf(bt + 131072);
        var lms = (1 << lbt) - 1, dms = (1 << dbt) - 1;
        var lpos = pos;
        for(;; lpos = pos){
            // bits read, code
            var c = lm[$0c5e3e04f495ba65$var$bits16(dat, pos) & lms], sym = c >> 4;
            pos += c & 15;
            if (pos > tbts) {
                if (noSt) $0c5e3e04f495ba65$var$err(0);
                break;
            }
            if (!c) $0c5e3e04f495ba65$var$err(2);
            if (sym < 256) buf[bt++] = sym;
            else if (sym == 256) {
                lpos = pos, lm = null;
                break;
            } else {
                var add = sym - 254;
                // no extra bits needed if less
                if (sym > 264) {
                    // index
                    var i = sym - 257, b = $0c5e3e04f495ba65$var$fleb[i];
                    add = $0c5e3e04f495ba65$var$bits(dat, pos, (1 << b) - 1) + $0c5e3e04f495ba65$var$fl[i];
                    pos += b;
                }
                // dist
                var d = dm[$0c5e3e04f495ba65$var$bits16(dat, pos) & dms], dsym = d >> 4;
                if (!d) $0c5e3e04f495ba65$var$err(3);
                pos += d & 15;
                var dt = $0c5e3e04f495ba65$var$fd[dsym];
                if (dsym > 3) {
                    var b = $0c5e3e04f495ba65$var$fdeb[dsym];
                    dt += $0c5e3e04f495ba65$var$bits16(dat, pos) & (1 << b) - 1, pos += b;
                }
                if (pos > tbts) {
                    if (noSt) $0c5e3e04f495ba65$var$err(0);
                    break;
                }
                if (resize) cbuf(bt + 131072);
                var end = bt + add;
                if (bt < dt) {
                    var shift = dl - dt, dend = Math.min(dt, end);
                    if (shift + bt < 0) $0c5e3e04f495ba65$var$err(3);
                    for(; bt < dend; ++bt)buf[bt] = dict[shift + bt];
                }
                for(; bt < end; ++bt)buf[bt] = buf[bt - dt];
            }
        }
        st.l = lm, st.p = lpos, st.b = bt, st.f = final;
        if (lm) final = 1, st.m = lbt, st.d = dm, st.n = dbt;
    }while (!final);
    // don't reallocate for streams or user buffers
    return bt != buf.length && noBuf ? $0c5e3e04f495ba65$var$slc(buf, 0, bt) : buf.subarray(0, bt);
};
// starting at p, write the minimum number of bits that can hold v to d
var $0c5e3e04f495ba65$var$wbits = function(d, p, v) {
    v <<= p & 7;
    var o = p / 8 | 0;
    d[o] |= v;
    d[o + 1] |= v >> 8;
};
// starting at p, write the minimum number of bits (>8) that can hold v to d
var $0c5e3e04f495ba65$var$wbits16 = function(d, p, v) {
    v <<= p & 7;
    var o = p / 8 | 0;
    d[o] |= v;
    d[o + 1] |= v >> 8;
    d[o + 2] |= v >> 16;
};
// creates code lengths from a frequency table
var $0c5e3e04f495ba65$var$hTree = function(d, mb) {
    // Need extra info to make a tree
    var t = [];
    for(var i = 0; i < d.length; ++i)if (d[i]) t.push({
        s: i,
        f: d[i]
    });
    var s = t.length;
    var t2 = t.slice();
    if (!s) return {
        t: $0c5e3e04f495ba65$var$et,
        l: 0
    };
    if (s == 1) {
        var v = new $0c5e3e04f495ba65$var$u8(t[0].s + 1);
        v[t[0].s] = 1;
        return {
            t: v,
            l: 1
        };
    }
    t.sort(function(a, b) {
        return a.f - b.f;
    });
    // after i2 reaches last ind, will be stopped
    // freq must be greater than largest possible number of symbols
    t.push({
        s: -1,
        f: 25001
    });
    var l = t[0], r = t[1], i0 = 0, i1 = 1, i2 = 2;
    t[0] = {
        s: -1,
        f: l.f + r.f,
        l: l,
        r: r
    };
    // efficient algorithm from UZIP.js
    // i0 is lookbehind, i2 is lookahead - after processing two low-freq
    // symbols that combined have high freq, will start processing i2 (high-freq,
    // non-composite) symbols instead
    // see https://reddit.com/r/photopea/comments/ikekht/uzipjs_questions/
    while(i1 != s - 1){
        l = t[t[i0].f < t[i2].f ? i0++ : i2++];
        r = t[i0 != i1 && t[i0].f < t[i2].f ? i0++ : i2++];
        t[i1++] = {
            s: -1,
            f: l.f + r.f,
            l: l,
            r: r
        };
    }
    var maxSym = t2[0].s;
    for(var i = 1; i < s; ++i)if (t2[i].s > maxSym) maxSym = t2[i].s;
    // code lengths
    var tr = new $0c5e3e04f495ba65$var$u16(maxSym + 1);
    // max bits in tree
    var mbt = $0c5e3e04f495ba65$var$ln(t[i1 - 1], tr, 0);
    if (mbt > mb) {
        // more algorithms from UZIP.js
        // TODO: find out how this code works (debt)
        //  ind    debt
        var i = 0, dt = 0;
        //    left            cost
        var lft = mbt - mb, cst = 1 << lft;
        t2.sort(function(a, b) {
            return tr[b.s] - tr[a.s] || a.f - b.f;
        });
        for(; i < s; ++i){
            var i2_1 = t2[i].s;
            if (tr[i2_1] > mb) {
                dt += cst - (1 << mbt - tr[i2_1]);
                tr[i2_1] = mb;
            } else break;
        }
        dt >>= lft;
        while(dt > 0){
            var i2_2 = t2[i].s;
            if (tr[i2_2] < mb) dt -= 1 << mb - tr[i2_2]++ - 1;
            else ++i;
        }
        for(; i >= 0 && dt; --i){
            var i2_3 = t2[i].s;
            if (tr[i2_3] == mb) {
                --tr[i2_3];
                ++dt;
            }
        }
        mbt = mb;
    }
    return {
        t: new $0c5e3e04f495ba65$var$u8(tr),
        l: mbt
    };
};
// get the max length and assign length codes
var $0c5e3e04f495ba65$var$ln = function(n, l, d) {
    return n.s == -1 ? Math.max($0c5e3e04f495ba65$var$ln(n.l, l, d + 1), $0c5e3e04f495ba65$var$ln(n.r, l, d + 1)) : l[n.s] = d;
};
// length codes generation
var $0c5e3e04f495ba65$var$lc = function(c) {
    var s = c.length;
    // Note that the semicolon was intentional
    while(s && !c[--s]);
    var cl = new $0c5e3e04f495ba65$var$u16(++s);
    //  ind      num         streak
    var cli = 0, cln = c[0], cls = 1;
    var w = function(v) {
        cl[cli++] = v;
    };
    for(var i = 1; i <= s; ++i)if (c[i] == cln && i != s) ++cls;
    else {
        if (!cln && cls > 2) {
            for(; cls > 138; cls -= 138)w(32754);
            if (cls > 2) {
                w(cls > 10 ? cls - 11 << 5 | 28690 : cls - 3 << 5 | 12305);
                cls = 0;
            }
        } else if (cls > 3) {
            w(cln), --cls;
            for(; cls > 6; cls -= 6)w(8304);
            if (cls > 2) w(cls - 3 << 5 | 8208), cls = 0;
        }
        while(cls--)w(cln);
        cls = 1;
        cln = c[i];
    }
    return {
        c: cl.subarray(0, cli),
        n: s
    };
};
// calculate the length of output from tree, code lengths
var $0c5e3e04f495ba65$var$clen = function(cf, cl) {
    var l = 0;
    for(var i = 0; i < cl.length; ++i)l += cf[i] * cl[i];
    return l;
};
// writes a fixed block
// returns the new bit pos
var $0c5e3e04f495ba65$var$wfblk = function(out, pos, dat) {
    // no need to write 00 as type: TypedArray defaults to 0
    var s = dat.length;
    var o = $0c5e3e04f495ba65$var$shft(pos + 2);
    out[o] = s & 255;
    out[o + 1] = s >> 8;
    out[o + 2] = out[o] ^ 255;
    out[o + 3] = out[o + 1] ^ 255;
    for(var i = 0; i < s; ++i)out[o + i + 4] = dat[i];
    return (o + 4 + s) * 8;
};
// writes a block
var $0c5e3e04f495ba65$var$wblk = function(dat, out, final, syms, lf, df, eb, li, bs, bl, p) {
    $0c5e3e04f495ba65$var$wbits(out, p++, final);
    ++lf[256];
    var _a = $0c5e3e04f495ba65$var$hTree(lf, 15), dlt = _a.t, mlb = _a.l;
    var _b = $0c5e3e04f495ba65$var$hTree(df, 15), ddt = _b.t, mdb = _b.l;
    var _c = $0c5e3e04f495ba65$var$lc(dlt), lclt = _c.c, nlc = _c.n;
    var _d = $0c5e3e04f495ba65$var$lc(ddt), lcdt = _d.c, ndc = _d.n;
    var lcfreq = new $0c5e3e04f495ba65$var$u16(19);
    for(var i = 0; i < lclt.length; ++i)++lcfreq[lclt[i] & 31];
    for(var i = 0; i < lcdt.length; ++i)++lcfreq[lcdt[i] & 31];
    var _e = $0c5e3e04f495ba65$var$hTree(lcfreq, 7), lct = _e.t, mlcb = _e.l;
    var nlcc = 19;
    for(; nlcc > 4 && !lct[$0c5e3e04f495ba65$var$clim[nlcc - 1]]; --nlcc);
    var flen = bl + 5 << 3;
    var ftlen = $0c5e3e04f495ba65$var$clen(lf, $0c5e3e04f495ba65$var$flt) + $0c5e3e04f495ba65$var$clen(df, $0c5e3e04f495ba65$var$fdt) + eb;
    var dtlen = $0c5e3e04f495ba65$var$clen(lf, dlt) + $0c5e3e04f495ba65$var$clen(df, ddt) + eb + 14 + 3 * nlcc + $0c5e3e04f495ba65$var$clen(lcfreq, lct) + 2 * lcfreq[16] + 3 * lcfreq[17] + 7 * lcfreq[18];
    if (bs >= 0 && flen <= ftlen && flen <= dtlen) return $0c5e3e04f495ba65$var$wfblk(out, p, dat.subarray(bs, bs + bl));
    var lm, ll, dm, dl;
    $0c5e3e04f495ba65$var$wbits(out, p, 1 + (dtlen < ftlen)), p += 2;
    if (dtlen < ftlen) {
        lm = $0c5e3e04f495ba65$var$hMap(dlt, mlb, 0), ll = dlt, dm = $0c5e3e04f495ba65$var$hMap(ddt, mdb, 0), dl = ddt;
        var llm = $0c5e3e04f495ba65$var$hMap(lct, mlcb, 0);
        $0c5e3e04f495ba65$var$wbits(out, p, nlc - 257);
        $0c5e3e04f495ba65$var$wbits(out, p + 5, ndc - 1);
        $0c5e3e04f495ba65$var$wbits(out, p + 10, nlcc - 4);
        p += 14;
        for(var i = 0; i < nlcc; ++i)$0c5e3e04f495ba65$var$wbits(out, p + 3 * i, lct[$0c5e3e04f495ba65$var$clim[i]]);
        p += 3 * nlcc;
        var lcts = [
            lclt,
            lcdt
        ];
        for(var it = 0; it < 2; ++it){
            var clct = lcts[it];
            for(var i = 0; i < clct.length; ++i){
                var len = clct[i] & 31;
                $0c5e3e04f495ba65$var$wbits(out, p, llm[len]), p += lct[len];
                if (len > 15) $0c5e3e04f495ba65$var$wbits(out, p, clct[i] >> 5 & 127), p += clct[i] >> 12;
            }
        }
    } else lm = $0c5e3e04f495ba65$var$flm, ll = $0c5e3e04f495ba65$var$flt, dm = $0c5e3e04f495ba65$var$fdm, dl = $0c5e3e04f495ba65$var$fdt;
    for(var i = 0; i < li; ++i){
        var sym = syms[i];
        if (sym > 255) {
            var len = sym >> 18 & 31;
            $0c5e3e04f495ba65$var$wbits16(out, p, lm[len + 257]), p += ll[len + 257];
            if (len > 7) $0c5e3e04f495ba65$var$wbits(out, p, sym >> 23 & 31), p += $0c5e3e04f495ba65$var$fleb[len];
            var dst = sym & 31;
            $0c5e3e04f495ba65$var$wbits16(out, p, dm[dst]), p += dl[dst];
            if (dst > 3) $0c5e3e04f495ba65$var$wbits16(out, p, sym >> 5 & 8191), p += $0c5e3e04f495ba65$var$fdeb[dst];
        } else $0c5e3e04f495ba65$var$wbits16(out, p, lm[sym]), p += ll[sym];
    }
    $0c5e3e04f495ba65$var$wbits16(out, p, lm[256]);
    return p + ll[256];
};
// deflate options (nice << 13) | chain
var $0c5e3e04f495ba65$var$deo = /*#__PURE__*/ new $0c5e3e04f495ba65$var$i32([
    65540,
    131080,
    131088,
    131104,
    262176,
    1048704,
    1048832,
    2114560,
    2117632
]);
// empty
var $0c5e3e04f495ba65$var$et = /*#__PURE__*/ new $0c5e3e04f495ba65$var$u8(0);
// compresses data into a raw DEFLATE buffer
var $0c5e3e04f495ba65$var$dflt = function(dat, lvl, plvl, pre, post, st) {
    var s = st.z || dat.length;
    var o = new $0c5e3e04f495ba65$var$u8(pre + s + 5 * (1 + Math.ceil(s / 7000)) + post);
    // writing to this writes to the output buffer
    var w = o.subarray(pre, o.length - post);
    var lst = st.l;
    var pos = (st.r || 0) & 7;
    if (lvl) {
        if (pos) w[0] = st.r >> 3;
        var opt = $0c5e3e04f495ba65$var$deo[lvl - 1];
        var n = opt >> 13, c = opt & 8191;
        var msk_1 = (1 << plvl) - 1;
        //    prev 2-byte val map    curr 2-byte val map
        var prev = st.p || new $0c5e3e04f495ba65$var$u16(32768), head = st.h || new $0c5e3e04f495ba65$var$u16(msk_1 + 1);
        var bs1_1 = Math.ceil(plvl / 3), bs2_1 = 2 * bs1_1;
        var hsh = function(i) {
            return (dat[i] ^ dat[i + 1] << bs1_1 ^ dat[i + 2] << bs2_1) & msk_1;
        };
        // 24576 is an arbitrary number of maximum symbols per block
        // 424 buffer for last block
        var syms = new $0c5e3e04f495ba65$var$i32(25000);
        // length/literal freq   distance freq
        var lf = new $0c5e3e04f495ba65$var$u16(288), df = new $0c5e3e04f495ba65$var$u16(32);
        //  l/lcnt  exbits  index          l/lind  waitdx          blkpos
        var lc_1 = 0, eb = 0, i = st.i || 0, li = 0, wi = st.w || 0, bs = 0;
        for(; i + 2 < s; ++i){
            // hash value
            var hv = hsh(i);
            // index mod 32768    previous index mod
            var imod = i & 32767, pimod = head[hv];
            prev[imod] = pimod;
            head[hv] = imod;
            // We always should modify head and prev, but only add symbols if
            // this data is not yet processed ("wait" for wait index)
            if (wi <= i) {
                // bytes remaining
                var rem = s - i;
                if ((lc_1 > 7000 || li > 24576) && (rem > 423 || !lst)) {
                    pos = $0c5e3e04f495ba65$var$wblk(dat, w, 0, syms, lf, df, eb, li, bs, i - bs, pos);
                    li = lc_1 = eb = 0, bs = i;
                    for(var j = 0; j < 286; ++j)lf[j] = 0;
                    for(var j = 0; j < 30; ++j)df[j] = 0;
                }
                //  len    dist   chain
                var l = 2, d = 0, ch_1 = c, dif = imod - pimod & 32767;
                if (rem > 2 && hv == hsh(i - dif)) {
                    var maxn = Math.min(n, rem) - 1;
                    var maxd = Math.min(32767, i);
                    // max possible length
                    // not capped at dif because decompressors implement "rolling" index population
                    var ml = Math.min(258, rem);
                    while(dif <= maxd && --ch_1 && imod != pimod){
                        if (dat[i + l] == dat[i + l - dif]) {
                            var nl = 0;
                            for(; nl < ml && dat[i + nl] == dat[i + nl - dif]; ++nl);
                            if (nl > l) {
                                l = nl, d = dif;
                                // break out early when we reach "nice" (we are satisfied enough)
                                if (nl > maxn) break;
                                // now, find the rarest 2-byte sequence within this
                                // length of literals and search for that instead.
                                // Much faster than just using the start
                                var mmd = Math.min(dif, nl - 2);
                                var md = 0;
                                for(var j = 0; j < mmd; ++j){
                                    var ti = i - dif + j & 32767;
                                    var pti = prev[ti];
                                    var cd = ti - pti & 32767;
                                    if (cd > md) md = cd, pimod = ti;
                                }
                            }
                        }
                        // check the previous match
                        imod = pimod, pimod = prev[imod];
                        dif += imod - pimod & 32767;
                    }
                }
                // d will be nonzero only when a match was found
                if (d) {
                    // store both dist and len data in one int32
                    // Make sure this is recognized as a len/dist with 28th bit (2^28)
                    syms[li++] = 268435456 | $0c5e3e04f495ba65$var$revfl[l] << 18 | $0c5e3e04f495ba65$var$revfd[d];
                    var lin = $0c5e3e04f495ba65$var$revfl[l] & 31, din = $0c5e3e04f495ba65$var$revfd[d] & 31;
                    eb += $0c5e3e04f495ba65$var$fleb[lin] + $0c5e3e04f495ba65$var$fdeb[din];
                    ++lf[257 + lin];
                    ++df[din];
                    wi = i + l;
                    ++lc_1;
                } else {
                    syms[li++] = dat[i];
                    ++lf[dat[i]];
                }
            }
        }
        for(i = Math.max(i, wi); i < s; ++i){
            syms[li++] = dat[i];
            ++lf[dat[i]];
        }
        pos = $0c5e3e04f495ba65$var$wblk(dat, w, lst, syms, lf, df, eb, li, bs, i - bs, pos);
        if (!lst) {
            st.r = pos & 7 | w[pos / 8 | 0] << 3;
            // shft(pos) now 1 less if pos & 7 != 0
            pos -= 7;
            st.h = head, st.p = prev, st.i = i, st.w = wi;
        }
    } else {
        for(var i = st.w || 0; i < s + lst; i += 65535){
            // end
            var e = i + 65535;
            if (e >= s) {
                // write final block
                w[pos / 8 | 0] = lst;
                e = s;
            }
            pos = $0c5e3e04f495ba65$var$wfblk(w, pos + 1, dat.subarray(i, e));
        }
        st.i = s;
    }
    return $0c5e3e04f495ba65$var$slc(o, 0, pre + $0c5e3e04f495ba65$var$shft(pos) + post);
};
// CRC32 table
var $0c5e3e04f495ba65$var$crct = /*#__PURE__*/ function() {
    var t = new Int32Array(256);
    for(var i = 0; i < 256; ++i){
        var c = i, k = 9;
        while(--k)c = (c & 1 && -306674912) ^ c >>> 1;
        t[i] = c;
    }
    return t;
}();
// CRC32
var $0c5e3e04f495ba65$var$crc = function() {
    var c = -1;
    return {
        p: function(d) {
            // closures have awful performance
            var cr = c;
            for(var i = 0; i < d.length; ++i)cr = $0c5e3e04f495ba65$var$crct[cr & 255 ^ d[i]] ^ cr >>> 8;
            c = cr;
        },
        d: function() {
            return ~c;
        }
    };
};
// Adler32
var $0c5e3e04f495ba65$var$adler = function() {
    var a = 1, b = 0;
    return {
        p: function(d) {
            // closures have awful performance
            var n = a, m = b;
            var l = d.length | 0;
            for(var i = 0; i != l;){
                var e = Math.min(i + 2655, l);
                for(; i < e; ++i)m += n += d[i];
                n = (n & 65535) + 15 * (n >> 16), m = (m & 65535) + 15 * (m >> 16);
            }
            a = n, b = m;
        },
        d: function() {
            a %= 65521, b %= 65521;
            return (a & 255) << 24 | (a & 0xFF00) << 8 | (b & 255) << 8 | b >> 8;
        }
    };
};
// deflate with opts
var $0c5e3e04f495ba65$var$dopt = function(dat, opt, pre, post, st) {
    if (!st) {
        st = {
            l: 1
        };
        if (opt.dictionary) {
            var dict = opt.dictionary.subarray(-32768);
            var newDat = new $0c5e3e04f495ba65$var$u8(dict.length + dat.length);
            newDat.set(dict);
            newDat.set(dat, dict.length);
            dat = newDat;
            st.w = dict.length;
        }
    }
    return $0c5e3e04f495ba65$var$dflt(dat, opt.level == null ? 6 : opt.level, opt.mem == null ? st.l ? Math.ceil(Math.max(8, Math.min(13, Math.log(dat.length))) * 1.5) : 20 : 12 + opt.mem, pre, post, st);
};
// Walmart object spread
var $0c5e3e04f495ba65$var$mrg = function(a, b) {
    var o = {};
    for(var k in a)o[k] = a[k];
    for(var k in b)o[k] = b[k];
    return o;
};
// worker clone
// This is possibly the craziest part of the entire codebase, despite how simple it may seem.
// The only parameter to this function is a closure that returns an array of variables outside of the function scope.
// We're going to try to figure out the variable names used in the closure as strings because that is crucial for workerization.
// We will return an object mapping of true variable name to value (basically, the current scope as a JS object).
// The reason we can't just use the original variable names is minifiers mangling the toplevel scope.
// This took me three weeks to figure out how to do.
var $0c5e3e04f495ba65$var$wcln = function(fn, fnStr, td) {
    var dt = fn();
    var st = fn.toString();
    var ks = st.slice(st.indexOf('[') + 1, st.lastIndexOf(']')).replace(/\s+/g, '').split(',');
    for(var i = 0; i < dt.length; ++i){
        var v = dt[i], k = ks[i];
        if (typeof v == 'function') {
            fnStr += ';' + k + '=';
            var st_1 = v.toString();
            if (v.prototype) {
                // for global objects
                if (st_1.indexOf('[native code]') != -1) {
                    var spInd = st_1.indexOf(' ', 8) + 1;
                    fnStr += st_1.slice(spInd, st_1.indexOf('(', spInd));
                } else {
                    fnStr += st_1;
                    for(var t in v.prototype)fnStr += ';' + k + '.prototype.' + t + '=' + v.prototype[t].toString();
                }
            } else fnStr += st_1;
        } else td[k] = v;
    }
    return fnStr;
};
var $0c5e3e04f495ba65$var$ch = [];
// clone bufs
var $0c5e3e04f495ba65$var$cbfs = function(v) {
    var tl = [];
    for(var k in v)if (v[k].buffer) tl.push((v[k] = new v[k].constructor(v[k])).buffer);
    return tl;
};
// use a worker to execute code
var $0c5e3e04f495ba65$var$wrkr = function(fns, init, id, cb) {
    if (!$0c5e3e04f495ba65$var$ch[id]) {
        var fnStr = '', td_1 = {}, m = fns.length - 1;
        for(var i = 0; i < m; ++i)fnStr = $0c5e3e04f495ba65$var$wcln(fns[i], fnStr, td_1);
        $0c5e3e04f495ba65$var$ch[id] = {
            c: $0c5e3e04f495ba65$var$wcln(fns[m], fnStr, td_1),
            e: td_1
        };
    }
    var td = $0c5e3e04f495ba65$var$mrg({}, $0c5e3e04f495ba65$var$ch[id].e);
    return $0c5e3e04f495ba65$var$wk($0c5e3e04f495ba65$var$ch[id].c + ';onmessage=function(e){for(var k in e.data)self[k]=e.data[k];onmessage=' + init.toString() + '}', id, td, $0c5e3e04f495ba65$var$cbfs(td), cb);
};
// base async inflate fn
var $0c5e3e04f495ba65$var$bInflt = function() {
    return [
        $0c5e3e04f495ba65$var$u8,
        $0c5e3e04f495ba65$var$u16,
        $0c5e3e04f495ba65$var$i32,
        $0c5e3e04f495ba65$var$fleb,
        $0c5e3e04f495ba65$var$fdeb,
        $0c5e3e04f495ba65$var$clim,
        $0c5e3e04f495ba65$var$fl,
        $0c5e3e04f495ba65$var$fd,
        $0c5e3e04f495ba65$var$flrm,
        $0c5e3e04f495ba65$var$fdrm,
        $0c5e3e04f495ba65$var$rev,
        $0c5e3e04f495ba65$var$ec,
        $0c5e3e04f495ba65$var$hMap,
        $0c5e3e04f495ba65$var$max,
        $0c5e3e04f495ba65$var$bits,
        $0c5e3e04f495ba65$var$bits16,
        $0c5e3e04f495ba65$var$shft,
        $0c5e3e04f495ba65$var$slc,
        $0c5e3e04f495ba65$var$err,
        $0c5e3e04f495ba65$var$inflt,
        $0c5e3e04f495ba65$export$90366d8b308ba94a,
        $0c5e3e04f495ba65$var$pbf,
        $0c5e3e04f495ba65$var$gopt
    ];
};
var $0c5e3e04f495ba65$var$bDflt = function() {
    return [
        $0c5e3e04f495ba65$var$u8,
        $0c5e3e04f495ba65$var$u16,
        $0c5e3e04f495ba65$var$i32,
        $0c5e3e04f495ba65$var$fleb,
        $0c5e3e04f495ba65$var$fdeb,
        $0c5e3e04f495ba65$var$clim,
        $0c5e3e04f495ba65$var$revfl,
        $0c5e3e04f495ba65$var$revfd,
        $0c5e3e04f495ba65$var$flm,
        $0c5e3e04f495ba65$var$flt,
        $0c5e3e04f495ba65$var$fdm,
        $0c5e3e04f495ba65$var$fdt,
        $0c5e3e04f495ba65$var$rev,
        $0c5e3e04f495ba65$var$deo,
        $0c5e3e04f495ba65$var$et,
        $0c5e3e04f495ba65$var$hMap,
        $0c5e3e04f495ba65$var$wbits,
        $0c5e3e04f495ba65$var$wbits16,
        $0c5e3e04f495ba65$var$hTree,
        $0c5e3e04f495ba65$var$ln,
        $0c5e3e04f495ba65$var$lc,
        $0c5e3e04f495ba65$var$clen,
        $0c5e3e04f495ba65$var$wfblk,
        $0c5e3e04f495ba65$var$wblk,
        $0c5e3e04f495ba65$var$shft,
        $0c5e3e04f495ba65$var$slc,
        $0c5e3e04f495ba65$var$dflt,
        $0c5e3e04f495ba65$var$dopt,
        $0c5e3e04f495ba65$export$21533ff51b8a0b4a,
        $0c5e3e04f495ba65$var$pbf
    ];
};
// gzip extra
var $0c5e3e04f495ba65$var$gze = function() {
    return [
        $0c5e3e04f495ba65$var$gzh,
        $0c5e3e04f495ba65$var$gzhl,
        $0c5e3e04f495ba65$var$wbytes,
        $0c5e3e04f495ba65$var$crc,
        $0c5e3e04f495ba65$var$crct
    ];
};
// gunzip extra
var $0c5e3e04f495ba65$var$guze = function() {
    return [
        $0c5e3e04f495ba65$var$gzs,
        $0c5e3e04f495ba65$var$gzl
    ];
};
// zlib extra
var $0c5e3e04f495ba65$var$zle = function() {
    return [
        $0c5e3e04f495ba65$var$zlh,
        $0c5e3e04f495ba65$var$wbytes,
        $0c5e3e04f495ba65$var$adler
    ];
};
// unzlib extra
var $0c5e3e04f495ba65$var$zule = function() {
    return [
        $0c5e3e04f495ba65$var$zls
    ];
};
// post buf
var $0c5e3e04f495ba65$var$pbf = function(msg) {
    return postMessage(msg, [
        msg.buffer
    ]);
};
// get opts
var $0c5e3e04f495ba65$var$gopt = function(o) {
    return o && {
        out: o.size && new $0c5e3e04f495ba65$var$u8(o.size),
        dictionary: o.dictionary
    };
};
// async helper
var $0c5e3e04f495ba65$var$cbify = function(dat, opts, fns, init, id, cb) {
    var w = $0c5e3e04f495ba65$var$wrkr(fns, init, id, function(err, dat) {
        w.terminate();
        cb(err, dat);
    });
    w.postMessage([
        dat,
        opts
    ], opts.consume ? [
        dat.buffer
    ] : []);
    return function() {
        w.terminate();
    };
};
// auto stream
var $0c5e3e04f495ba65$var$astrm = function(strm) {
    strm.ondata = function(dat, final) {
        return postMessage([
            dat,
            final
        ], [
            dat.buffer
        ]);
    };
    return function(ev) {
        if (ev.data[0]) {
            strm.push(ev.data[0], ev.data[1]);
            postMessage([
                ev.data[0].length
            ]);
        } else strm.flush(ev.data[1]);
    };
};
// async stream attach
var $0c5e3e04f495ba65$var$astrmify = function(fns, strm, opts, init, id, flush, ext) {
    var t;
    var w = $0c5e3e04f495ba65$var$wrkr(fns, init, id, function(err, dat) {
        if (err) w.terminate(), strm.ondata.call(strm, err);
        else if (!Array.isArray(dat)) ext(dat);
        else if (dat.length == 1) {
            strm.queuedSize -= dat[0];
            if (strm.ondrain) strm.ondrain(dat[0]);
        } else {
            if (dat[1]) w.terminate();
            strm.ondata.call(strm, err, dat[0], dat[1]);
        }
    });
    w.postMessage(opts);
    strm.queuedSize = 0;
    strm.push = function(d, f) {
        if (!strm.ondata) $0c5e3e04f495ba65$var$err(5);
        if (t) strm.ondata($0c5e3e04f495ba65$var$err(4, 0, 1), null, !!f);
        strm.queuedSize += d.length;
        // can fail for cross-realm Uint8Array, but ok - only a small performance penalty
        w.postMessage([
            d,
            t = f
        ], d.buffer instanceof ArrayBuffer ? [
            d.buffer
        ] : []);
    };
    strm.terminate = function() {
        w.terminate();
    };
    if (flush) strm.flush = function(sync) {
        w.postMessage([
            0,
            sync
        ]);
    };
};
// read 2 bytes
var $0c5e3e04f495ba65$var$b2 = function(d, b) {
    return d[b] | d[b + 1] << 8;
};
// read 4 bytes
var $0c5e3e04f495ba65$var$b4 = function(d, b) {
    return (d[b] | d[b + 1] << 8 | d[b + 2] << 16 | d[b + 3] << 24) >>> 0;
};
// read 8 bytes
var $0c5e3e04f495ba65$var$b8 = function(d, b) {
    return $0c5e3e04f495ba65$var$b4(d, b) + $0c5e3e04f495ba65$var$b4(d, b + 4) * 4294967296;
};
// write bytes
var $0c5e3e04f495ba65$var$wbytes = function(d, b, v) {
    for(; v; ++b)d[b] = v, v >>>= 8;
};
// gzip header
var $0c5e3e04f495ba65$var$gzh = function(c, o) {
    var fn = o.filename;
    c[0] = 31, c[1] = 139, c[2] = 8, c[8] = o.level < 2 ? 4 : o.level == 9 ? 2 : 0, c[9] = 3; // assume Unix
    if (o.mtime != 0) $0c5e3e04f495ba65$var$wbytes(c, 4, Math.floor(new Date(o.mtime || Date.now()) / 1000));
    if (fn) {
        c[3] = 8;
        for(var i = 0; i <= fn.length; ++i)c[i + 10] = fn.charCodeAt(i);
    }
};
// gzip footer: -8 to -4 = CRC, -4 to -0 is length
// gzip start
var $0c5e3e04f495ba65$var$gzs = function(d) {
    if (d[0] != 31 || d[1] != 139 || d[2] != 8) $0c5e3e04f495ba65$var$err(6, 'invalid gzip data');
    var flg = d[3];
    var st = 10;
    if (flg & 4) st += (d[10] | d[11] << 8) + 2;
    for(var zs = (flg >> 3 & 1) + (flg >> 4 & 1); zs > 0; zs -= !d[st++]);
    return st + (flg & 2);
};
// gzip length
var $0c5e3e04f495ba65$var$gzl = function(d) {
    var l = d.length;
    return (d[l - 4] | d[l - 3] << 8 | d[l - 2] << 16 | d[l - 1] << 24) >>> 0;
};
// gzip header length
var $0c5e3e04f495ba65$var$gzhl = function(o) {
    return 10 + (o.filename ? o.filename.length + 1 : 0);
};
// zlib header
var $0c5e3e04f495ba65$var$zlh = function(c, o) {
    var lv = o.level, fl = lv == 0 ? 0 : lv < 6 ? 1 : lv == 9 ? 3 : 2;
    c[0] = 120, c[1] = fl << 6 | (o.dictionary && 32);
    c[1] |= 31 - (c[0] << 8 | c[1]) % 31;
    if (o.dictionary) {
        var h = $0c5e3e04f495ba65$var$adler();
        h.p(o.dictionary);
        $0c5e3e04f495ba65$var$wbytes(c, 2, h.d());
    }
};
// zlib start
var $0c5e3e04f495ba65$var$zls = function(d, dict) {
    if ((d[0] & 15) != 8 || d[0] >> 4 > 7 || (d[0] << 8 | d[1]) % 31) $0c5e3e04f495ba65$var$err(6, 'invalid zlib data');
    if ((d[1] >> 5 & 1) == +!dict) $0c5e3e04f495ba65$var$err(6, 'invalid zlib data: ' + (d[1] & 32 ? 'need' : 'unexpected') + ' dictionary');
    return (d[1] >> 3 & 4) + 2;
};
function $0c5e3e04f495ba65$var$StrmOpt(opts, cb) {
    if (typeof opts == 'function') cb = opts, opts = {};
    this.ondata = cb;
    return opts;
}
/**
 * Streaming DEFLATE compression
 */ var $0c5e3e04f495ba65$export$ae157b6234afe138 = /*#__PURE__*/ function() {
    function Deflate(opts, cb) {
        if (typeof opts == 'function') cb = opts, opts = {};
        this.ondata = cb;
        this.o = opts || {};
        this.s = {
            l: 0,
            i: 32768,
            w: 32768,
            z: 32768
        };
        // Buffer length must always be 0 mod 32768 for index calculations to be correct when modifying head and prev
        // 98304 = 32768 (lookback) + 65536 (common chunk size)
        this.b = new $0c5e3e04f495ba65$var$u8(98304);
        if (this.o.dictionary) {
            var dict = this.o.dictionary.subarray(-32768);
            this.b.set(dict, 32768 - dict.length);
            this.s.i = 32768 - dict.length;
        }
    }
    Deflate.prototype.p = function(c, f) {
        this.ondata($0c5e3e04f495ba65$var$dopt(c, this.o, 0, 0, this.s), f);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Deflate.prototype.push = function(chunk, final) {
        if (!this.ondata) $0c5e3e04f495ba65$var$err(5);
        if (this.s.l) $0c5e3e04f495ba65$var$err(4);
        var endLen = chunk.length + this.s.z;
        if (endLen > this.b.length) {
            if (endLen > 2 * this.b.length - 32768) {
                var newBuf = new $0c5e3e04f495ba65$var$u8(endLen & -32768);
                newBuf.set(this.b.subarray(0, this.s.z));
                this.b = newBuf;
            }
            var split = this.b.length - this.s.z;
            this.b.set(chunk.subarray(0, split), this.s.z);
            this.s.z = this.b.length;
            this.p(this.b, false);
            this.b.set(this.b.subarray(-32768));
            this.b.set(chunk.subarray(split), 32768);
            this.s.z = chunk.length - split + 32768;
            this.s.i = 32766, this.s.w = 32768;
        } else {
            this.b.set(chunk, this.s.z);
            this.s.z += chunk.length;
        }
        this.s.l = final & 1;
        if (this.s.z > this.s.w + 8191 || final) {
            this.p(this.b, final || false);
            this.s.w = this.s.i, this.s.i -= 2;
        }
        if (final) {
            // cleanup unneeded buffers/state to reduce memory usage
            this.s = this.o = {};
            this.b = $0c5e3e04f495ba65$var$et;
        }
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * deflated output for small inputs.
     * @param sync Whether to flush to a byte boundary. A sync flush takes 4-5
     *             extra bytes, but guarantees all pushed data is immediately
     *             decompressible. A separate DEFLATE stream may be concatenated
     *             with the current output after a sync flush.
     */ Deflate.prototype.flush = function(sync) {
        if (!this.ondata) $0c5e3e04f495ba65$var$err(5);
        if (this.s.l) $0c5e3e04f495ba65$var$err(4);
        this.p(this.b, false);
        this.s.w = this.s.i, this.s.i -= 2;
        // could technically skip writing the type-0 block for (this.s.r & 7) == 0,
        // but the deterministic trailer (00 00 FF FF) is useful in some situations
        if (sync) {
            var c = new $0c5e3e04f495ba65$var$u8(6);
            c[0] = this.s.r >> 3;
            // write empty, non-final type-0 block
            var ep = $0c5e3e04f495ba65$var$wfblk(c, this.s.r, $0c5e3e04f495ba65$var$et);
            this.s.r = 0;
            this.ondata(c.subarray(0, ep >> 3), false);
        }
    };
    return Deflate;
}();
/**
 * Asynchronous streaming DEFLATE compression
 */ var $0c5e3e04f495ba65$export$84e526fabcba03e3 = /*#__PURE__*/ function() {
    function AsyncDeflate(opts, cb) {
        $0c5e3e04f495ba65$var$astrmify([
            $0c5e3e04f495ba65$var$bDflt,
            function() {
                return [
                    $0c5e3e04f495ba65$var$astrm,
                    $0c5e3e04f495ba65$export$ae157b6234afe138
                ];
            }
        ], this, $0c5e3e04f495ba65$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $0c5e3e04f495ba65$export$ae157b6234afe138(ev.data);
            onmessage = $0c5e3e04f495ba65$var$astrm(strm);
        }, 6, 1);
    }
    return AsyncDeflate;
}();
function $0c5e3e04f495ba65$export$2316623ecd1285ab(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $0c5e3e04f495ba65$var$err(7);
    return $0c5e3e04f495ba65$var$cbify(data, opts, [
        $0c5e3e04f495ba65$var$bDflt
    ], function(ev) {
        return $0c5e3e04f495ba65$var$pbf($0c5e3e04f495ba65$export$21533ff51b8a0b4a(ev.data[0], ev.data[1]));
    }, 0, cb);
}
function $0c5e3e04f495ba65$export$21533ff51b8a0b4a(data, opts) {
    return $0c5e3e04f495ba65$var$dopt(data, opts || {}, 0, 0);
}
/**
 * Streaming DEFLATE decompression
 */ var $0c5e3e04f495ba65$export$d1de70a877d6e43c = /*#__PURE__*/ function() {
    function Inflate(opts, cb) {
        // no StrmOpt here to avoid adding to workerizer
        if (typeof opts == 'function') cb = opts, opts = {};
        this.ondata = cb;
        var dict = opts && opts.dictionary && opts.dictionary.subarray(-32768);
        this.s = {
            i: 0,
            b: dict ? dict.length : 0
        };
        this.o = new $0c5e3e04f495ba65$var$u8(32768);
        this.p = new $0c5e3e04f495ba65$var$u8(0);
        if (dict) this.o.set(dict);
    }
    Inflate.prototype.e = function(c) {
        if (!this.ondata) $0c5e3e04f495ba65$var$err(5);
        if (this.d) $0c5e3e04f495ba65$var$err(4);
        if (!this.p.length) this.p = c;
        else if (c.length) {
            var n = new $0c5e3e04f495ba65$var$u8(this.p.length + c.length);
            n.set(this.p), n.set(c, this.p.length), this.p = n;
        }
    };
    Inflate.prototype.c = function(final) {
        this.s.i = +(this.d = final || false);
        var bts = this.s.b;
        var dt = $0c5e3e04f495ba65$var$inflt(this.p, this.s, this.o);
        this.ondata($0c5e3e04f495ba65$var$slc(dt, bts, this.s.b), this.d);
        this.o = $0c5e3e04f495ba65$var$slc(dt, this.s.b - 32768), this.s.b = this.o.length;
        this.p = $0c5e3e04f495ba65$var$slc(this.p, this.s.p / 8 | 0), this.s.p &= 7;
    };
    /**
     * Pushes a chunk to be inflated
     * @param chunk The chunk to push
     * @param final Whether this is the final chunk
     */ Inflate.prototype.push = function(chunk, final) {
        this.e(chunk), this.c(final);
    };
    return Inflate;
}();
/**
 * Asynchronous streaming DEFLATE decompression
 */ var $0c5e3e04f495ba65$export$fff8358d6dbaa9cc = /*#__PURE__*/ function() {
    function AsyncInflate(opts, cb) {
        $0c5e3e04f495ba65$var$astrmify([
            $0c5e3e04f495ba65$var$bInflt,
            function() {
                return [
                    $0c5e3e04f495ba65$var$astrm,
                    $0c5e3e04f495ba65$export$d1de70a877d6e43c
                ];
            }
        ], this, $0c5e3e04f495ba65$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $0c5e3e04f495ba65$export$d1de70a877d6e43c(ev.data);
            onmessage = $0c5e3e04f495ba65$var$astrm(strm);
        }, 7, 0);
    }
    return AsyncInflate;
}();
function $0c5e3e04f495ba65$export$cae1ce83fe4a1782(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $0c5e3e04f495ba65$var$err(7);
    return $0c5e3e04f495ba65$var$cbify(data, opts, [
        $0c5e3e04f495ba65$var$bInflt
    ], function(ev) {
        return $0c5e3e04f495ba65$var$pbf($0c5e3e04f495ba65$export$90366d8b308ba94a(ev.data[0], $0c5e3e04f495ba65$var$gopt(ev.data[1])));
    }, 1, cb);
}
function $0c5e3e04f495ba65$export$90366d8b308ba94a(data, opts) {
    return $0c5e3e04f495ba65$var$inflt(data, {
        i: 2
    }, opts && opts.out, opts && opts.dictionary);
}
// before you yell at me for not just using extends, my reason is that TS inheritance is hard to workerize.
/**
 * Streaming GZIP compression
 */ var $0c5e3e04f495ba65$export$8e4b66d280bf8342 = /*#__PURE__*/ function() {
    function Gzip(opts, cb) {
        this.c = $0c5e3e04f495ba65$var$crc();
        this.l = 0;
        this.v = 1;
        $0c5e3e04f495ba65$export$ae157b6234afe138.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be GZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gzip.prototype.push = function(chunk, final) {
        this.c.p(chunk);
        this.l += chunk.length;
        $0c5e3e04f495ba65$export$ae157b6234afe138.prototype.push.call(this, chunk, final);
    };
    Gzip.prototype.p = function(c, f) {
        var raw = $0c5e3e04f495ba65$var$dopt(c, this.o, this.v && $0c5e3e04f495ba65$var$gzhl(this.o), f && 8, this.s);
        if (this.v) $0c5e3e04f495ba65$var$gzh(raw, this.o), this.v = 0;
        if (f) $0c5e3e04f495ba65$var$wbytes(raw, raw.length - 8, this.c.d()), $0c5e3e04f495ba65$var$wbytes(raw, raw.length - 4, this.l);
        this.ondata(raw, f);
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * GZIPped output for small inputs.
     * @param sync Whether to flush to a byte boundary. A sync flush takes 4-5
     *             extra bytes, but guarantees all pushed data is immediately
     *             decompressible.
     */ Gzip.prototype.flush = function(sync) {
        $0c5e3e04f495ba65$export$ae157b6234afe138.prototype.flush.call(this, sync);
    };
    return Gzip;
}();
/**
 * Asynchronous streaming GZIP compression
 */ var $0c5e3e04f495ba65$export$b4c75ae96cdf708b = /*#__PURE__*/ function() {
    function AsyncGzip(opts, cb) {
        $0c5e3e04f495ba65$var$astrmify([
            $0c5e3e04f495ba65$var$bDflt,
            $0c5e3e04f495ba65$var$gze,
            function() {
                return [
                    $0c5e3e04f495ba65$var$astrm,
                    $0c5e3e04f495ba65$export$ae157b6234afe138,
                    $0c5e3e04f495ba65$export$8e4b66d280bf8342
                ];
            }
        ], this, $0c5e3e04f495ba65$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $0c5e3e04f495ba65$export$8e4b66d280bf8342(ev.data);
            onmessage = $0c5e3e04f495ba65$var$astrm(strm);
        }, 8, 1);
    }
    return AsyncGzip;
}();
function $0c5e3e04f495ba65$export$69f0ea7cf3a331a8(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $0c5e3e04f495ba65$var$err(7);
    return $0c5e3e04f495ba65$var$cbify(data, opts, [
        $0c5e3e04f495ba65$var$bDflt,
        $0c5e3e04f495ba65$var$gze,
        function() {
            return [
                $0c5e3e04f495ba65$export$3d616c3fb3e15483
            ];
        }
    ], function(ev) {
        return $0c5e3e04f495ba65$var$pbf($0c5e3e04f495ba65$export$3d616c3fb3e15483(ev.data[0], ev.data[1]));
    }, 2, cb);
}
function $0c5e3e04f495ba65$export$3d616c3fb3e15483(data, opts) {
    if (!opts) opts = {};
    var c = $0c5e3e04f495ba65$var$crc(), l = data.length;
    c.p(data);
    var d = $0c5e3e04f495ba65$var$dopt(data, opts, $0c5e3e04f495ba65$var$gzhl(opts), 8), s = d.length;
    return $0c5e3e04f495ba65$var$gzh(d, opts), $0c5e3e04f495ba65$var$wbytes(d, s - 8, c.d()), $0c5e3e04f495ba65$var$wbytes(d, s - 4, l), d;
}
/**
 * Streaming single or multi-member GZIP decompression
 */ var $0c5e3e04f495ba65$export$4cb607de6db70415 = /*#__PURE__*/ function() {
    function Gunzip(opts, cb) {
        this.v = 1;
        this.r = 0;
        $0c5e3e04f495ba65$export$d1de70a877d6e43c.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be GUNZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gunzip.prototype.push = function(chunk, final) {
        $0c5e3e04f495ba65$export$d1de70a877d6e43c.prototype.e.call(this, chunk);
        this.r += chunk.length;
        if (this.v) {
            var p = this.p.subarray(this.v - 1);
            var s = p.length > 3 ? $0c5e3e04f495ba65$var$gzs(p) : 4;
            if (s > p.length) {
                if (!final) return;
            } else if (this.v > 1 && this.onmember) this.onmember(this.r - p.length);
            this.p = p.subarray(s), this.v = 0;
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        $0c5e3e04f495ba65$export$d1de70a877d6e43c.prototype.c.call(this, 0);
        // process concatenated GZIP
        if (this.s.f && !this.s.l) {
            this.v = $0c5e3e04f495ba65$var$shft(this.s.p) + 9;
            this.s = {
                i: 0
            };
            this.o = new $0c5e3e04f495ba65$var$u8(0);
            this.push(new $0c5e3e04f495ba65$var$u8(0), final);
        } else if (final) $0c5e3e04f495ba65$export$d1de70a877d6e43c.prototype.c.call(this, final);
    };
    return Gunzip;
}();
/**
 * Asynchronous streaming single or multi-member GZIP decompression
 */ var $0c5e3e04f495ba65$export$d5adcdd968132151 = /*#__PURE__*/ function() {
    function AsyncGunzip(opts, cb) {
        var _this = this;
        $0c5e3e04f495ba65$var$astrmify([
            $0c5e3e04f495ba65$var$bInflt,
            $0c5e3e04f495ba65$var$guze,
            function() {
                return [
                    $0c5e3e04f495ba65$var$astrm,
                    $0c5e3e04f495ba65$export$d1de70a877d6e43c,
                    $0c5e3e04f495ba65$export$4cb607de6db70415
                ];
            }
        ], this, $0c5e3e04f495ba65$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $0c5e3e04f495ba65$export$4cb607de6db70415(ev.data);
            strm.onmember = function(offset) {
                return postMessage(offset);
            };
            onmessage = $0c5e3e04f495ba65$var$astrm(strm);
        }, 9, 0, function(offset) {
            return _this.onmember && _this.onmember(offset);
        });
    }
    return AsyncGunzip;
}();
function $0c5e3e04f495ba65$export$b6df3e950734d697(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $0c5e3e04f495ba65$var$err(7);
    return $0c5e3e04f495ba65$var$cbify(data, opts, [
        $0c5e3e04f495ba65$var$bInflt,
        $0c5e3e04f495ba65$var$guze,
        function() {
            return [
                $0c5e3e04f495ba65$export$c80456f7aaba691c
            ];
        }
    ], function(ev) {
        return $0c5e3e04f495ba65$var$pbf($0c5e3e04f495ba65$export$c80456f7aaba691c(ev.data[0], ev.data[1]));
    }, 3, cb);
}
function $0c5e3e04f495ba65$export$c80456f7aaba691c(data, opts) {
    var st = $0c5e3e04f495ba65$var$gzs(data);
    if (st + 8 > data.length) $0c5e3e04f495ba65$var$err(6, 'invalid gzip data');
    return $0c5e3e04f495ba65$var$inflt(data.subarray(st, -8), {
        i: 2
    }, opts && opts.out || new $0c5e3e04f495ba65$var$u8($0c5e3e04f495ba65$var$gzl(data)), opts && opts.dictionary);
}
/**
 * Streaming Zlib compression
 */ var $0c5e3e04f495ba65$export$4187ccf2467013b9 = /*#__PURE__*/ function() {
    function Zlib(opts, cb) {
        this.c = $0c5e3e04f495ba65$var$adler();
        this.v = 1;
        $0c5e3e04f495ba65$export$ae157b6234afe138.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be zlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Zlib.prototype.push = function(chunk, final) {
        this.c.p(chunk);
        $0c5e3e04f495ba65$export$ae157b6234afe138.prototype.push.call(this, chunk, final);
    };
    Zlib.prototype.p = function(c, f) {
        var raw = $0c5e3e04f495ba65$var$dopt(c, this.o, this.v && (this.o.dictionary ? 6 : 2), f && 4, this.s);
        if (this.v) $0c5e3e04f495ba65$var$zlh(raw, this.o), this.v = 0;
        if (f) $0c5e3e04f495ba65$var$wbytes(raw, raw.length - 4, this.c.d());
        this.ondata(raw, f);
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * zlibbed output for small inputs.
     * @param sync Whether to flush to a byte boundary. A sync flush takes 4-5
     *             extra bytes, but guarantees all pushed data is immediately
     *             decompressible.
     */ Zlib.prototype.flush = function(sync) {
        $0c5e3e04f495ba65$export$ae157b6234afe138.prototype.flush.call(this, sync);
    };
    return Zlib;
}();
/**
 * Asynchronous streaming Zlib compression
 */ var $0c5e3e04f495ba65$export$bedbe3a2c2136490 = /*#__PURE__*/ function() {
    function AsyncZlib(opts, cb) {
        $0c5e3e04f495ba65$var$astrmify([
            $0c5e3e04f495ba65$var$bDflt,
            $0c5e3e04f495ba65$var$zle,
            function() {
                return [
                    $0c5e3e04f495ba65$var$astrm,
                    $0c5e3e04f495ba65$export$ae157b6234afe138,
                    $0c5e3e04f495ba65$export$4187ccf2467013b9
                ];
            }
        ], this, $0c5e3e04f495ba65$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $0c5e3e04f495ba65$export$4187ccf2467013b9(ev.data);
            onmessage = $0c5e3e04f495ba65$var$astrm(strm);
        }, 10, 1);
    }
    return AsyncZlib;
}();
function $0c5e3e04f495ba65$export$925212de7058410b(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $0c5e3e04f495ba65$var$err(7);
    return $0c5e3e04f495ba65$var$cbify(data, opts, [
        $0c5e3e04f495ba65$var$bDflt,
        $0c5e3e04f495ba65$var$zle,
        function() {
            return [
                $0c5e3e04f495ba65$export$f87121a6d50aff25
            ];
        }
    ], function(ev) {
        return $0c5e3e04f495ba65$var$pbf($0c5e3e04f495ba65$export$f87121a6d50aff25(ev.data[0], ev.data[1]));
    }, 4, cb);
}
function $0c5e3e04f495ba65$export$f87121a6d50aff25(data, opts) {
    if (!opts) opts = {};
    var a = $0c5e3e04f495ba65$var$adler();
    a.p(data);
    var d = $0c5e3e04f495ba65$var$dopt(data, opts, opts.dictionary ? 6 : 2, 4);
    return $0c5e3e04f495ba65$var$zlh(d, opts), $0c5e3e04f495ba65$var$wbytes(d, d.length - 4, a.d()), d;
}
/**
 * Streaming Zlib decompression
 */ var $0c5e3e04f495ba65$export$af2424f875ff1b17 = /*#__PURE__*/ function() {
    function Unzlib(opts, cb) {
        $0c5e3e04f495ba65$export$d1de70a877d6e43c.call(this, opts, cb);
        this.v = opts && opts.dictionary ? 2 : 1;
    }
    /**
     * Pushes a chunk to be unzlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Unzlib.prototype.push = function(chunk, final) {
        $0c5e3e04f495ba65$export$d1de70a877d6e43c.prototype.e.call(this, chunk);
        if (this.v) {
            if (this.p.length < 6 && !final) return;
            this.p = this.p.subarray($0c5e3e04f495ba65$var$zls(this.p, this.v - 1)), this.v = 0;
        }
        if (final) {
            if (this.p.length < 4) $0c5e3e04f495ba65$var$err(6, 'invalid zlib data');
            this.p = this.p.subarray(0, -4);
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        $0c5e3e04f495ba65$export$d1de70a877d6e43c.prototype.c.call(this, final);
    };
    return Unzlib;
}();
/**
 * Asynchronous streaming Zlib decompression
 */ var $0c5e3e04f495ba65$export$cf6668790220dcad = /*#__PURE__*/ function() {
    function AsyncUnzlib(opts, cb) {
        $0c5e3e04f495ba65$var$astrmify([
            $0c5e3e04f495ba65$var$bInflt,
            $0c5e3e04f495ba65$var$zule,
            function() {
                return [
                    $0c5e3e04f495ba65$var$astrm,
                    $0c5e3e04f495ba65$export$d1de70a877d6e43c,
                    $0c5e3e04f495ba65$export$af2424f875ff1b17
                ];
            }
        ], this, $0c5e3e04f495ba65$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $0c5e3e04f495ba65$export$af2424f875ff1b17(ev.data);
            onmessage = $0c5e3e04f495ba65$var$astrm(strm);
        }, 11, 0);
    }
    return AsyncUnzlib;
}();
function $0c5e3e04f495ba65$export$ca7cbb494e731274(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $0c5e3e04f495ba65$var$err(7);
    return $0c5e3e04f495ba65$var$cbify(data, opts, [
        $0c5e3e04f495ba65$var$bInflt,
        $0c5e3e04f495ba65$var$zule,
        function() {
            return [
                $0c5e3e04f495ba65$export$9ec8134f0f1b9fc6
            ];
        }
    ], function(ev) {
        return $0c5e3e04f495ba65$var$pbf($0c5e3e04f495ba65$export$9ec8134f0f1b9fc6(ev.data[0], $0c5e3e04f495ba65$var$gopt(ev.data[1])));
    }, 5, cb);
}
function $0c5e3e04f495ba65$export$9ec8134f0f1b9fc6(data, opts) {
    return $0c5e3e04f495ba65$var$inflt(data.subarray($0c5e3e04f495ba65$var$zls(data, opts && opts.dictionary), -4), {
        i: 2
    }, opts && opts.out, opts && opts.dictionary);
}
/**
 * Streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var $0c5e3e04f495ba65$export$578fe199ef655b76 = /*#__PURE__*/ function() {
    function Decompress(opts, cb) {
        this.o = $0c5e3e04f495ba65$var$StrmOpt.call(this, opts, cb) || {};
        this.G = $0c5e3e04f495ba65$export$4cb607de6db70415;
        this.I = $0c5e3e04f495ba65$export$d1de70a877d6e43c;
        this.Z = $0c5e3e04f495ba65$export$af2424f875ff1b17;
    }
    // init substream
    // overriden by AsyncDecompress
    Decompress.prototype.i = function() {
        var _this = this;
        this.s.ondata = function(dat, final) {
            _this.ondata(dat, final);
        };
    };
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Decompress.prototype.push = function(chunk, final) {
        if (!this.ondata) $0c5e3e04f495ba65$var$err(5);
        if (!this.s) {
            if (this.p && this.p.length) {
                var n = new $0c5e3e04f495ba65$var$u8(this.p.length + chunk.length);
                n.set(this.p), n.set(chunk, this.p.length);
            } else this.p = chunk;
            if (this.p.length > 2) {
                this.s = this.p[0] == 31 && this.p[1] == 139 && this.p[2] == 8 ? new this.G(this.o) : (this.p[0] & 15) != 8 || this.p[0] >> 4 > 7 || (this.p[0] << 8 | this.p[1]) % 31 ? new this.I(this.o) : new this.Z(this.o);
                this.i();
                this.s.push(this.p, final);
                this.p = null;
            }
        } else this.s.push(chunk, final);
    };
    return Decompress;
}();
/**
 * Asynchronous streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var $0c5e3e04f495ba65$export$ae2c1d81988d4b43 = /*#__PURE__*/ function() {
    function AsyncDecompress(opts, cb) {
        $0c5e3e04f495ba65$export$578fe199ef655b76.call(this, opts, cb);
        this.queuedSize = 0;
        this.G = $0c5e3e04f495ba65$export$d5adcdd968132151;
        this.I = $0c5e3e04f495ba65$export$fff8358d6dbaa9cc;
        this.Z = $0c5e3e04f495ba65$export$cf6668790220dcad;
    }
    AsyncDecompress.prototype.i = function() {
        var _this = this;
        this.s.ondata = function(err, dat, final) {
            _this.ondata(err, dat, final);
        };
        this.s.ondrain = function(size) {
            _this.queuedSize -= size;
            if (_this.ondrain) _this.ondrain(size);
        };
    };
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ AsyncDecompress.prototype.push = function(chunk, final) {
        this.queuedSize += chunk.length;
        $0c5e3e04f495ba65$export$578fe199ef655b76.prototype.push.call(this, chunk, final);
    };
    return AsyncDecompress;
}();
function $0c5e3e04f495ba65$export$678d868aab8fb3c7(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $0c5e3e04f495ba65$var$err(7);
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? $0c5e3e04f495ba65$export$b6df3e950734d697(data, opts, cb) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? $0c5e3e04f495ba65$export$cae1ce83fe4a1782(data, opts, cb) : $0c5e3e04f495ba65$export$ca7cbb494e731274(data, opts, cb);
}
function $0c5e3e04f495ba65$export$c4bdbbbc9a4faabe(data, opts) {
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? $0c5e3e04f495ba65$export$c80456f7aaba691c(data, opts) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? $0c5e3e04f495ba65$export$90366d8b308ba94a(data, opts) : $0c5e3e04f495ba65$export$9ec8134f0f1b9fc6(data, opts);
}
// flatten a directory structure
var $0c5e3e04f495ba65$var$fltn = function(d, p, t, o) {
    for(var k in d){
        var val = d[k], n = p + k, op = o;
        if (Array.isArray(val)) op = $0c5e3e04f495ba65$var$mrg(o, val[1]), val = val[0];
        if (ArrayBuffer.isView(val)) t[n] = [
            val,
            op
        ];
        else {
            t[n += '/'] = [
                new $0c5e3e04f495ba65$var$u8(0),
                op
            ];
            $0c5e3e04f495ba65$var$fltn(val, n, t, o);
        }
    }
};
// text encoder
var $0c5e3e04f495ba65$var$te = typeof TextEncoder != 'undefined' && /*#__PURE__*/ new TextEncoder();
// text decoder
var $0c5e3e04f495ba65$var$td = typeof TextDecoder != 'undefined' && /*#__PURE__*/ new TextDecoder();
// text decoder stream
var $0c5e3e04f495ba65$var$tds = 0;
try {
    $0c5e3e04f495ba65$var$td.decode($0c5e3e04f495ba65$var$et, {
        stream: true
    });
    $0c5e3e04f495ba65$var$tds = 1;
} catch (e) {}
// decode UTF8
var $0c5e3e04f495ba65$var$dutf8 = function(d) {
    for(var r = '', i = 0;;){
        var c = d[i++];
        var eb = (c > 127) + (c > 223) + (c > 239);
        if (i + eb > d.length) return {
            s: r,
            r: $0c5e3e04f495ba65$var$slc(d, i - 1)
        };
        if (!eb) r += String.fromCharCode(c);
        else if (eb == 3) c = ((c & 15) << 18 | (d[i++] & 63) << 12 | (d[i++] & 63) << 6 | d[i++] & 63) - 65536, r += String.fromCharCode(55296 | c >> 10, 56320 | c & 1023);
        else if (eb & 1) r += String.fromCharCode((c & 31) << 6 | d[i++] & 63);
        else r += String.fromCharCode((c & 15) << 12 | (d[i++] & 63) << 6 | d[i++] & 63);
    }
};
/**
 * Streaming UTF-8 decoding
 */ var $0c5e3e04f495ba65$export$ba46860a31c72e94 = /*#__PURE__*/ function() {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is decoded
     */ function DecodeUTF8(cb) {
        this.ondata = cb;
        if ($0c5e3e04f495ba65$var$tds) this.t = new TextDecoder();
        else this.p = $0c5e3e04f495ba65$var$et;
    }
    /**
     * Pushes a chunk to be decoded from UTF-8 binary
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ DecodeUTF8.prototype.push = function(chunk, final) {
        if (!this.ondata) $0c5e3e04f495ba65$var$err(5);
        final = !!final;
        if (this.t) {
            this.ondata(this.t.decode(chunk, {
                stream: true
            }), final);
            if (final) {
                if (this.t.decode().length) $0c5e3e04f495ba65$var$err(8);
                this.t = null;
            }
            return;
        }
        if (!this.p) $0c5e3e04f495ba65$var$err(4);
        var dat = new $0c5e3e04f495ba65$var$u8(this.p.length + chunk.length);
        dat.set(this.p);
        dat.set(chunk, this.p.length);
        var _a = $0c5e3e04f495ba65$var$dutf8(dat), s = _a.s, r = _a.r;
        if (final) {
            if (r.length) $0c5e3e04f495ba65$var$err(8);
            this.p = null;
        } else this.p = r;
        this.ondata(s, final);
    };
    return DecodeUTF8;
}();
/**
 * Streaming UTF-8 encoding
 */ var $0c5e3e04f495ba65$export$283f13d12b1b210e = /*#__PURE__*/ function() {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is encoded
     */ function EncodeUTF8(cb) {
        this.ondata = cb;
    }
    /**
     * Pushes a chunk to be encoded to UTF-8
     * @param chunk The string data to push
     * @param final Whether this is the last chunk
     */ EncodeUTF8.prototype.push = function(chunk, final) {
        if (!this.ondata) $0c5e3e04f495ba65$var$err(5);
        if (this.d) $0c5e3e04f495ba65$var$err(4);
        this.ondata($0c5e3e04f495ba65$export$366b39a6daa8ed7a(chunk), this.d = final || false);
    };
    return EncodeUTF8;
}();
function $0c5e3e04f495ba65$export$366b39a6daa8ed7a(str, latin1) {
    if (latin1) {
        var ar_1 = new $0c5e3e04f495ba65$var$u8(str.length);
        for(var i = 0; i < str.length; ++i)ar_1[i] = str.charCodeAt(i);
        return ar_1;
    }
    if ($0c5e3e04f495ba65$var$te) return $0c5e3e04f495ba65$var$te.encode(str);
    var l = str.length;
    var ar = new $0c5e3e04f495ba65$var$u8(str.length + (str.length >> 1));
    var ai = 0;
    var w = function(v) {
        ar[ai++] = v;
    };
    for(var i = 0; i < l; ++i){
        if (ai + 5 > ar.length) {
            var n = new $0c5e3e04f495ba65$var$u8(ai + 8 + (l - i << 1));
            n.set(ar);
            ar = n;
        }
        var c = str.charCodeAt(i);
        if (c < 128 || latin1) w(c);
        else if (c < 2048) w(192 | c >> 6), w(128 | c & 63);
        else if (c > 55295 && c < 57344) c = 65536 + (c & 1047552) | str.charCodeAt(++i) & 1023, w(240 | c >> 18), w(128 | c >> 12 & 63), w(128 | c >> 6 & 63), w(128 | c & 63);
        else w(224 | c >> 12), w(128 | c >> 6 & 63), w(128 | c & 63);
    }
    return $0c5e3e04f495ba65$var$slc(ar, 0, ai);
}
function $0c5e3e04f495ba65$export$adb211f8cb999894(dat, latin1) {
    if (latin1) {
        var r = '';
        for(var i = 0; i < dat.length; i += 16384)r += String.fromCharCode.apply(null, dat.subarray(i, i + 16384));
        return r;
    } else if ($0c5e3e04f495ba65$var$td) return $0c5e3e04f495ba65$var$td.decode(dat);
    else {
        var _a = $0c5e3e04f495ba65$var$dutf8(dat), s = _a.s, r = _a.r;
        if (r.length) $0c5e3e04f495ba65$var$err(8);
        return s;
    }
}
// deflate bit flag
var $0c5e3e04f495ba65$var$dbf = function(l) {
    return l == 1 ? 3 : l < 6 ? 2 : l == 9 ? 1 : 0;
};
// skip local zip header
var $0c5e3e04f495ba65$var$slzh = function(d, b) {
    return b + 30 + $0c5e3e04f495ba65$var$b2(d, b + 26) + $0c5e3e04f495ba65$var$b2(d, b + 28);
};
// read zip header
var $0c5e3e04f495ba65$var$zh = function(d, b, z) {
    var fnl = $0c5e3e04f495ba65$var$b2(d, b + 28), efl = $0c5e3e04f495ba65$var$b2(d, b + 30), fn = $0c5e3e04f495ba65$export$adb211f8cb999894(d.subarray(b + 46, b + 46 + fnl), !($0c5e3e04f495ba65$var$b2(d, b + 8) & 2048)), es = b + 46 + fnl;
    var _a = $0c5e3e04f495ba65$var$z64hs(d, es, efl, z, $0c5e3e04f495ba65$var$b4(d, b + 20), $0c5e3e04f495ba65$var$b4(d, b + 24), $0c5e3e04f495ba65$var$b4(d, b + 42)), sc = _a[0], su = _a[1], off = _a[2];
    return [
        $0c5e3e04f495ba65$var$b2(d, b + 10),
        sc,
        su,
        fn,
        es + efl + $0c5e3e04f495ba65$var$b2(d, b + 32),
        off
    ];
};
// read zip64 header sizes
var $0c5e3e04f495ba65$var$z64hs = function(d, b, l, z, sc, su, off) {
    var nsc = sc == 4294967295, nsu = su == 4294967295, noff = off == 4294967295, e = b + l;
    var nf = nsc + nsu + noff;
    if (z && nf) {
        for(; b + 4 < e; b += 4 + $0c5e3e04f495ba65$var$b2(d, b + 2)){
            if ($0c5e3e04f495ba65$var$b2(d, b) == 1) return [
                nsc ? $0c5e3e04f495ba65$var$b8(d, b + 4 + 8 * nsu) : sc,
                nsu ? $0c5e3e04f495ba65$var$b8(d, b + 4) : su,
                noff ? $0c5e3e04f495ba65$var$b8(d, b + 4 + 8 * (nsu + nsc)) : off,
                1
            ];
        }
        // z == 2 for unknown whether or not zip64
        if (z < 2) $0c5e3e04f495ba65$var$err(13);
    }
    return [
        sc,
        su,
        off,
        0
    ];
};
// extra field length
var $0c5e3e04f495ba65$var$exfl = function(ex) {
    var le = 0;
    if (ex) for(var k in ex){
        var l = ex[k].length;
        if (l > 65535) $0c5e3e04f495ba65$var$err(9);
        le += l + 4;
    }
    return le;
};
// write zip header
var $0c5e3e04f495ba65$var$wzh = function(d, b, f, fn, u, c, ce, co) {
    var fl = fn.length, ex = f.extra, col = co && co.length;
    var exl = $0c5e3e04f495ba65$var$exfl(ex);
    $0c5e3e04f495ba65$var$wbytes(d, b, ce != null ? 0x2014B50 : 0x4034B50), b += 4;
    if (ce != null) d[b++] = 20, d[b++] = f.os;
    d[b] = 20, b += 2; // spec compliance? what's that?
    d[b++] = f.flag << 1 | (c < 0 && 8), d[b++] = u && 8;
    d[b++] = f.compression & 255, d[b++] = f.compression >> 8;
    var dt = new Date(f.mtime == null ? Date.now() : f.mtime), y = dt.getFullYear() - 1980;
    if (y < 0 || y > 119) $0c5e3e04f495ba65$var$err(10);
    $0c5e3e04f495ba65$var$wbytes(d, b, y << 25 | dt.getMonth() + 1 << 21 | dt.getDate() << 16 | dt.getHours() << 11 | dt.getMinutes() << 5 | dt.getSeconds() >> 1), b += 4;
    if (c != -1) {
        $0c5e3e04f495ba65$var$wbytes(d, b, f.crc);
        $0c5e3e04f495ba65$var$wbytes(d, b + 4, c < 0 ? -c - 2 : c);
        $0c5e3e04f495ba65$var$wbytes(d, b + 8, f.size);
    }
    $0c5e3e04f495ba65$var$wbytes(d, b + 12, fl);
    $0c5e3e04f495ba65$var$wbytes(d, b + 14, exl), b += 16;
    if (ce != null) {
        $0c5e3e04f495ba65$var$wbytes(d, b, col);
        $0c5e3e04f495ba65$var$wbytes(d, b + 6, f.attrs);
        $0c5e3e04f495ba65$var$wbytes(d, b + 10, ce), b += 14;
    }
    d.set(fn, b);
    b += fl;
    if (exl) for(var k in ex){
        var exf = ex[k], l = exf.length;
        $0c5e3e04f495ba65$var$wbytes(d, b, +k);
        $0c5e3e04f495ba65$var$wbytes(d, b + 2, l);
        d.set(exf, b + 4), b += 4 + l;
    }
    if (col) d.set(co, b), b += col;
    return b;
};
// write zip footer (end of central directory)
var $0c5e3e04f495ba65$var$wzf = function(o, b, c, d, e) {
    $0c5e3e04f495ba65$var$wbytes(o, b, 0x6054B50); // skip disk
    $0c5e3e04f495ba65$var$wbytes(o, b + 8, c);
    $0c5e3e04f495ba65$var$wbytes(o, b + 10, c);
    $0c5e3e04f495ba65$var$wbytes(o, b + 12, d);
    $0c5e3e04f495ba65$var$wbytes(o, b + 16, e);
};
/**
 * A pass-through stream to keep data uncompressed in a ZIP archive.
 */ var $0c5e3e04f495ba65$export$2b25194e1767ea06 = /*#__PURE__*/ function() {
    /**
     * Creates a pass-through stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     */ function ZipPassThrough(filename) {
        this.filename = filename;
        this.c = $0c5e3e04f495ba65$var$crc();
        this.size = 0;
        this.compression = 0;
    }
    /**
     * Processes a chunk and pushes to the output stream. You can override this
     * method in a subclass for custom behavior, but by default this passes
     * the data through. You must call this.ondata(err, chunk, final) at some
     * point in this method.
     * @param chunk The chunk to process
     * @param final Whether this is the last chunk
     */ ZipPassThrough.prototype.process = function(chunk, final) {
        this.ondata(null, chunk, final);
    };
    /**
     * Pushes a chunk to be added. If you are subclassing this with a custom
     * compression algorithm, note that you must push data from the source
     * file only, pre-compression.
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ ZipPassThrough.prototype.push = function(chunk, final) {
        if (!this.ondata) $0c5e3e04f495ba65$var$err(5);
        this.c.p(chunk);
        this.size += chunk.length;
        if (final) this.crc = this.c.d();
        // we shouldn't really do this cast, but properly handling ArrayBufferLike
        // makes the API unergonomic with Buffer
        this.process(chunk, final || false);
    };
    return ZipPassThrough;
}();
// I don't extend because TypeScript extension adds 1kB of runtime bloat
/**
 * Streaming DEFLATE compression for ZIP archives. Prefer using AsyncZipDeflate
 * for better performance
 */ var $0c5e3e04f495ba65$export$f7e481ca646388b6 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */ function ZipDeflate(filename, opts) {
        var _this = this;
        if (!opts) opts = {};
        $0c5e3e04f495ba65$export$2b25194e1767ea06.call(this, filename);
        this.d = new $0c5e3e04f495ba65$export$ae157b6234afe138(opts, function(dat, final) {
            _this.ondata(null, dat, final);
        });
        this.compression = 8;
        this.flag = $0c5e3e04f495ba65$var$dbf(opts.level);
    }
    ZipDeflate.prototype.process = function(chunk, final) {
        try {
            this.d.push(chunk, final);
        } catch (e) {
            this.ondata(e, null, final);
        }
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ ZipDeflate.prototype.push = function(chunk, final) {
        $0c5e3e04f495ba65$export$2b25194e1767ea06.prototype.push.call(this, chunk, final);
    };
    return ZipDeflate;
}();
/**
 * Asynchronous streaming DEFLATE compression for ZIP archives
 */ var $0c5e3e04f495ba65$export$ffb5e59e179924b2 = /*#__PURE__*/ function() {
    /**
     * Creates an asynchronous DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */ function AsyncZipDeflate(filename, opts) {
        var _this = this;
        if (!opts) opts = {};
        $0c5e3e04f495ba65$export$2b25194e1767ea06.call(this, filename);
        this.d = new $0c5e3e04f495ba65$export$84e526fabcba03e3(opts, function(err, dat, final) {
            _this.ondata(err, dat, final);
        });
        this.compression = 8;
        this.flag = $0c5e3e04f495ba65$var$dbf(opts.level);
        this.terminate = this.d.terminate;
    }
    AsyncZipDeflate.prototype.process = function(chunk, final) {
        this.d.push(chunk, final);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ AsyncZipDeflate.prototype.push = function(chunk, final) {
        $0c5e3e04f495ba65$export$2b25194e1767ea06.prototype.push.call(this, chunk, final);
    };
    return AsyncZipDeflate;
}();
// TODO: Better tree shaking
/**
 * A zippable archive to which files can incrementally be added
 */ var $0c5e3e04f495ba65$export$9a4d4a7c32a75d2f = /*#__PURE__*/ function() {
    /**
     * Creates an empty ZIP archive to which files can be added
     * @param cb The callback to call whenever data for the generated ZIP archive
     *           is available
     */ function Zip(cb) {
        this.ondata = cb;
        this.u = [];
        this.d = 1;
    }
    /**
     * Adds a file to the ZIP archive
     * @param file The file stream to add
     */ Zip.prototype.add = function(file) {
        var _this = this;
        if (!this.ondata) $0c5e3e04f495ba65$var$err(5);
        // finishing or finished
        if (this.d & 2) this.ondata($0c5e3e04f495ba65$var$err(4 + (this.d & 1) * 8, 0, 1), null, false);
        else {
            var f = $0c5e3e04f495ba65$export$366b39a6daa8ed7a(file.filename), fl_1 = f.length;
            var com = file.comment, o = com && $0c5e3e04f495ba65$export$366b39a6daa8ed7a(com);
            var u = fl_1 != file.filename.length || o && com.length != o.length;
            var hl_1 = fl_1 + $0c5e3e04f495ba65$var$exfl(file.extra) + 30;
            if (fl_1 > 65535) this.ondata($0c5e3e04f495ba65$var$err(11, 0, 1), null, false);
            var header = new $0c5e3e04f495ba65$var$u8(hl_1);
            $0c5e3e04f495ba65$var$wzh(header, 0, file, f, u, -1);
            var chks_1 = [
                header
            ];
            var pAll_1 = function() {
                for(var _i = 0, chks_2 = chks_1; _i < chks_2.length; _i++){
                    var chk = chks_2[_i];
                    _this.ondata(null, chk, false);
                }
                chks_1 = [];
            };
            var tr_1 = this.d;
            this.d = 0;
            var ind_1 = this.u.length;
            var uf_1 = $0c5e3e04f495ba65$var$mrg(file, {
                f: f,
                u: u,
                o: o,
                t: function() {
                    if (file.terminate) file.terminate();
                },
                r: function() {
                    pAll_1();
                    if (tr_1) {
                        var nxt = _this.u[ind_1 + 1];
                        if (nxt) nxt.r();
                        else _this.d = 1;
                    }
                    tr_1 = 1;
                }
            });
            var cl_1 = 0;
            file.ondata = function(err, dat, final) {
                if (err) {
                    _this.ondata(err, dat, final);
                    _this.terminate();
                } else {
                    cl_1 += dat.length;
                    chks_1.push(dat);
                    if (final) {
                        var dd = new $0c5e3e04f495ba65$var$u8(16);
                        $0c5e3e04f495ba65$var$wbytes(dd, 0, 0x8074B50);
                        $0c5e3e04f495ba65$var$wbytes(dd, 4, file.crc);
                        $0c5e3e04f495ba65$var$wbytes(dd, 8, cl_1);
                        $0c5e3e04f495ba65$var$wbytes(dd, 12, file.size);
                        chks_1.push(dd);
                        uf_1.c = cl_1, uf_1.b = hl_1 + cl_1 + 16, uf_1.crc = file.crc, uf_1.size = file.size;
                        if (tr_1) uf_1.r();
                        tr_1 = 1;
                    } else if (tr_1) pAll_1();
                }
            };
            this.u.push(uf_1);
        }
    };
    /**
     * Ends the process of adding files and prepares to emit the final chunks.
     * This *must* be called after adding all desired files for the resulting
     * ZIP file to work properly.
     */ Zip.prototype.end = function() {
        var _this = this;
        if (this.d & 2) {
            this.ondata($0c5e3e04f495ba65$var$err(4 + (this.d & 1) * 8, 0, 1), null, true);
            return;
        }
        if (this.d) this.e();
        else this.u.push({
            r: function() {
                if (!(_this.d & 1)) return;
                _this.u.splice(-1, 1);
                _this.e();
            },
            t: function() {}
        });
        this.d = 3;
    };
    Zip.prototype.e = function() {
        var bt = 0, l = 0, tl = 0;
        for(var _i = 0, _a = this.u; _i < _a.length; _i++){
            var f = _a[_i];
            tl += 46 + f.f.length + $0c5e3e04f495ba65$var$exfl(f.extra) + (f.o ? f.o.length : 0);
        }
        var out = new $0c5e3e04f495ba65$var$u8(tl + 22);
        for(var _b = 0, _c = this.u; _b < _c.length; _b++){
            var f = _c[_b];
            $0c5e3e04f495ba65$var$wzh(out, bt, f, f.f, f.u, -f.c - 2, l, f.o);
            bt += 46 + f.f.length + $0c5e3e04f495ba65$var$exfl(f.extra) + (f.o ? f.o.length : 0), l += f.b;
        }
        $0c5e3e04f495ba65$var$wzf(out, bt, this.u.length, tl, l);
        this.ondata(null, out, true);
        this.d = 2;
    };
    /**
     * A method to terminate any internal workers used by the stream. Subsequent
     * calls to add() will fail.
     */ Zip.prototype.terminate = function() {
        for(var _i = 0, _a = this.u; _i < _a.length; _i++){
            var f = _a[_i];
            f.t();
        }
        this.d = 2;
    };
    return Zip;
}();
function $0c5e3e04f495ba65$export$8901015135f2fb22(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $0c5e3e04f495ba65$var$err(7);
    var r = {};
    $0c5e3e04f495ba65$var$fltn(data, '', r, opts);
    var k = Object.keys(r);
    var lft = k.length, o = 0, tot = 0;
    var slft = lft, files = new Array(lft);
    var term = [];
    var tAll = function() {
        for(var i = 0; i < term.length; ++i)term[i]();
    };
    var cbd = function(a, b) {
        $0c5e3e04f495ba65$var$mt(function() {
            cb(a, b);
        });
    };
    $0c5e3e04f495ba65$var$mt(function() {
        cbd = cb;
    });
    var cbf = function() {
        var out = new $0c5e3e04f495ba65$var$u8(tot + 22), oe = o, cdl = tot - o;
        tot = 0;
        for(var i = 0; i < slft; ++i){
            var f = files[i];
            try {
                var l = f.c.length;
                $0c5e3e04f495ba65$var$wzh(out, tot, f, f.f, f.u, l);
                var badd = 30 + f.f.length + $0c5e3e04f495ba65$var$exfl(f.extra);
                var loc = tot + badd;
                out.set(f.c, loc);
                $0c5e3e04f495ba65$var$wzh(out, o, f, f.f, f.u, l, tot, f.m), o += 16 + badd + (f.m ? f.m.length : 0), tot = loc + l;
            } catch (e) {
                return cbd(e, null);
            }
        }
        $0c5e3e04f495ba65$var$wzf(out, o, files.length, cdl, oe);
        cbd(null, out);
    };
    if (!lft) cbf();
    var _loop_1 = function(i) {
        var fn = k[i];
        var _a = r[fn], file = _a[0], p = _a[1];
        var c = $0c5e3e04f495ba65$var$crc(), size = file.length;
        c.p(file);
        var f = $0c5e3e04f495ba65$export$366b39a6daa8ed7a(fn), s = f.length;
        var com = p.comment, m = com && $0c5e3e04f495ba65$export$366b39a6daa8ed7a(com), ms = m && m.length;
        var exl = $0c5e3e04f495ba65$var$exfl(p.extra);
        var compression = p.level == 0 ? 0 : 8;
        var cbl = function(e, d) {
            if (e) {
                tAll();
                cbd(e, null);
            } else {
                var l = d.length;
                files[i] = $0c5e3e04f495ba65$var$mrg(p, {
                    size: size,
                    crc: c.d(),
                    c: d,
                    f: f,
                    m: m,
                    u: s != fn.length || m && com.length != ms,
                    compression: compression
                });
                o += 30 + s + exl + l;
                tot += 76 + 2 * (s + exl) + (ms || 0) + l;
                if (!--lft) cbf();
            }
        };
        if (s > 65535) cbl($0c5e3e04f495ba65$var$err(11, 0, 1), null);
        if (!compression) cbl(null, file);
        else if (size < 160000) try {
            cbl(null, $0c5e3e04f495ba65$export$21533ff51b8a0b4a(file, p));
        } catch (e) {
            cbl(e, null);
        }
        else term.push($0c5e3e04f495ba65$export$2316623ecd1285ab(file, p, cbl));
    };
    // Cannot use lft because it can decrease
    for(var i = 0; i < slft; ++i)_loop_1(i);
    return tAll;
}
function $0c5e3e04f495ba65$export$eb1654f146d54eb3(data, opts) {
    if (!opts) opts = {};
    var r = {};
    var files = [];
    $0c5e3e04f495ba65$var$fltn(data, '', r, opts);
    var o = 0;
    var tot = 0;
    for(var fn in r){
        var _a = r[fn], file = _a[0], p = _a[1];
        var compression = p.level == 0 ? 0 : 8;
        var f = $0c5e3e04f495ba65$export$366b39a6daa8ed7a(fn), s = f.length;
        var com = p.comment, m = com && $0c5e3e04f495ba65$export$366b39a6daa8ed7a(com), ms = m && m.length;
        var exl = $0c5e3e04f495ba65$var$exfl(p.extra);
        if (s > 65535) $0c5e3e04f495ba65$var$err(11);
        var d = compression ? $0c5e3e04f495ba65$export$21533ff51b8a0b4a(file, p) : file, l = d.length;
        var c = $0c5e3e04f495ba65$var$crc();
        c.p(file);
        files.push($0c5e3e04f495ba65$var$mrg(p, {
            size: file.length,
            crc: c.d(),
            c: d,
            f: f,
            m: m,
            u: s != fn.length || m && com.length != ms,
            o: o,
            compression: compression
        }));
        o += 30 + s + exl + l;
        tot += 76 + 2 * (s + exl) + (ms || 0) + l;
    }
    var out = new $0c5e3e04f495ba65$var$u8(tot + 22), oe = o, cdl = tot - o;
    for(var i = 0; i < files.length; ++i){
        var f = files[i];
        $0c5e3e04f495ba65$var$wzh(out, f.o, f, f.f, f.u, f.c.length);
        var badd = 30 + f.f.length + $0c5e3e04f495ba65$var$exfl(f.extra);
        out.set(f.c, f.o + badd);
        $0c5e3e04f495ba65$var$wzh(out, o, f, f.f, f.u, f.c.length, f.o, f.m), o += 16 + badd + (f.m ? f.m.length : 0);
    }
    $0c5e3e04f495ba65$var$wzf(out, o, files.length, cdl, oe);
    return out;
}
/**
 * Streaming pass-through decompression for ZIP archives
 */ var $0c5e3e04f495ba65$export$93f81d5bbbb7c6bf = /*#__PURE__*/ function() {
    function UnzipPassThrough() {}
    UnzipPassThrough.prototype.push = function(chunk, final) {
        // same as ZipPassThrough: cast to retain Buffer ergonomics
        this.ondata(null, chunk, final);
    };
    UnzipPassThrough.compression = 0;
    return UnzipPassThrough;
}();
/**
 * Streaming DEFLATE decompression for ZIP archives. Prefer AsyncZipInflate for
 * better performance.
 */ var $0c5e3e04f495ba65$export$eb188945cc39e642 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */ function UnzipInflate() {
        var _this = this;
        this.i = new $0c5e3e04f495ba65$export$d1de70a877d6e43c(function(dat, final) {
            _this.ondata(null, dat, final);
        });
    }
    UnzipInflate.prototype.push = function(chunk, final) {
        try {
            this.i.push(chunk, final);
        } catch (e) {
            this.ondata(e, null, final);
        }
    };
    UnzipInflate.compression = 8;
    return UnzipInflate;
}();
/**
 * Asynchronous streaming DEFLATE decompression for ZIP archives
 */ var $0c5e3e04f495ba65$export$6235d84645dad4f9 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */ function AsyncUnzipInflate(_, sz) {
        var _this = this;
        if (sz < 320000) this.i = new $0c5e3e04f495ba65$export$d1de70a877d6e43c(function(dat, final) {
            _this.ondata(null, dat, final);
        });
        else {
            this.i = new $0c5e3e04f495ba65$export$fff8358d6dbaa9cc(function(err, dat, final) {
                _this.ondata(err, dat, final);
            });
            this.terminate = this.i.terminate;
        }
    }
    AsyncUnzipInflate.prototype.push = function(chunk, final) {
        if (this.i.terminate) chunk = $0c5e3e04f495ba65$var$slc(chunk, 0);
        this.i.push(chunk, final);
    };
    AsyncUnzipInflate.compression = 8;
    return AsyncUnzipInflate;
}();
/**
 * A ZIP archive decompression stream that emits files as they are discovered
 */ var $0c5e3e04f495ba65$export$9b7485f84cbaaa56 = /*#__PURE__*/ function() {
    /**
     * Creates a ZIP decompression stream
     * @param cb The callback to call whenever a file in the ZIP archive is found
     */ function Unzip(cb) {
        this.onfile = cb;
        this.k = [];
        this.o = {
            0: $0c5e3e04f495ba65$export$93f81d5bbbb7c6bf
        };
        this.p = $0c5e3e04f495ba65$var$et;
    }
    /**
     * Pushes a chunk to be unzipped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Unzip.prototype.push = function(chunk, final) {
        var _this = this;
        if (!this.onfile) $0c5e3e04f495ba65$var$err(5);
        if (!this.p) $0c5e3e04f495ba65$var$err(4);
        if (this.c > 0) {
            var len = Math.min(this.c, chunk.length);
            var toAdd = chunk.subarray(0, len);
            this.c -= len;
            if (this.d) this.d.push(toAdd, !this.c);
            else this.k[0].push(toAdd);
            chunk = chunk.subarray(len);
            if (chunk.length) return this.push(chunk, final);
        } else {
            var f = 0, i = 0, is = void 0, buf = void 0;
            if (!this.p.length) buf = chunk;
            else if (!chunk.length) buf = this.p;
            else {
                buf = new $0c5e3e04f495ba65$var$u8(this.p.length + chunk.length);
                buf.set(this.p), buf.set(chunk, this.p.length);
            }
            var l = buf.length, oc = this.c, add = oc && this.d;
            var _loop_2 = function() {
                var sig = $0c5e3e04f495ba65$var$b4(buf, i);
                if (sig == 0x4034B50) {
                    f = 1, is = i;
                    this_1.d = null;
                    this_1.c = 0;
                    var bf = $0c5e3e04f495ba65$var$b2(buf, i + 6), cmp_1 = $0c5e3e04f495ba65$var$b2(buf, i + 8), u = bf & 2048, dd = bf & 8, fnl = $0c5e3e04f495ba65$var$b2(buf, i + 26), es = $0c5e3e04f495ba65$var$b2(buf, i + 28);
                    if (l > i + 30 + fnl + es) {
                        var chks_3 = [];
                        this_1.k.unshift(chks_3);
                        f = 2;
                        var lsc = $0c5e3e04f495ba65$var$b4(buf, i + 18), lsu = $0c5e3e04f495ba65$var$b4(buf, i + 22);
                        var fn_1 = $0c5e3e04f495ba65$export$adb211f8cb999894(buf.subarray(i + 30, i += 30 + fnl), !u);
                        var _a = $0c5e3e04f495ba65$var$z64hs(buf, i, es, 2, lsc, lsu, 0), sc_1 = _a[0], su_1 = _a[1], z64 = _a[3];
                        if (dd) sc_1 = -1 - z64;
                        i += es;
                        this_1.c = sc_1;
                        var d_1;
                        var file_1 = {
                            name: fn_1,
                            compression: cmp_1,
                            start: function() {
                                if (!file_1.ondata) $0c5e3e04f495ba65$var$err(5);
                                if (!sc_1) file_1.ondata(null, $0c5e3e04f495ba65$var$et, true);
                                else {
                                    var ctr = _this.o[cmp_1];
                                    if (!ctr) file_1.ondata($0c5e3e04f495ba65$var$err(14, 'unknown compression type ' + cmp_1, 1), null, false);
                                    d_1 = sc_1 < 0 ? new ctr(fn_1) : new ctr(fn_1, sc_1, su_1);
                                    d_1.ondata = function(err, dat, final) {
                                        file_1.ondata(err, dat, final);
                                    };
                                    for(var _i = 0, chks_4 = chks_3; _i < chks_4.length; _i++){
                                        var dat = chks_4[_i];
                                        d_1.push(dat, false);
                                    }
                                    if (_this.k[0] == chks_3 && _this.c) _this.d = d_1;
                                    else d_1.push($0c5e3e04f495ba65$var$et, true);
                                }
                            },
                            terminate: function() {
                                if (d_1 && d_1.terminate) d_1.terminate();
                            }
                        };
                        if (sc_1 >= 0) file_1.size = sc_1, file_1.originalSize = su_1;
                        this_1.onfile(file_1);
                    }
                    return "break";
                } else if (oc) {
                    if (sig == 0x8074B50) {
                        is = i += 12 + (oc == -2 && 8), f = 3, this_1.c = 0;
                        return "break";
                    } else if (sig == 0x2014B50) {
                        is = i -= 4, f = 3, this_1.c = 0;
                        return "break";
                    }
                }
            };
            var this_1 = this;
            for(; i < l - 4; ++i){
                var state_1 = _loop_2();
                if (state_1 === "break") break;
            }
            this.p = $0c5e3e04f495ba65$var$et;
            if (oc < 0) {
                var dat = f ? buf.subarray(0, is - 12 - (oc == -2 && 8) - ($0c5e3e04f495ba65$var$b4(buf, is - 16) == 0x8074B50 && 4)) : buf.subarray(0, i);
                if (add) add.push(dat, !!f);
                else this.k[+(f == 2)].push(dat);
            }
            if (f & 2) return this.push(buf.subarray(i), final);
            this.p = buf.subarray(i);
        }
        if (final) {
            if (this.c) $0c5e3e04f495ba65$var$err(13);
            this.p = null;
        }
    };
    /**
     * Registers a decoder with the stream, allowing for files compressed with
     * the compression type provided to be expanded correctly
     * @param decoder The decoder constructor
     */ Unzip.prototype.register = function(decoder) {
        this.o[decoder.compression] = decoder;
    };
    return Unzip;
}();
var $0c5e3e04f495ba65$var$mt = typeof queueMicrotask == 'function' ? queueMicrotask : typeof setTimeout == 'function' ? setTimeout : function(fn) {
    fn();
};
function $0c5e3e04f495ba65$export$23c8d3f8757cab88(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $0c5e3e04f495ba65$var$err(7);
    var term = [];
    var tAll = function() {
        for(var i = 0; i < term.length; ++i)term[i]();
    };
    var files = {};
    var cbd = function(a, b) {
        $0c5e3e04f495ba65$var$mt(function() {
            cb(a, b);
        });
    };
    $0c5e3e04f495ba65$var$mt(function() {
        cbd = cb;
    });
    var e = data.length - 22;
    for(; $0c5e3e04f495ba65$var$b4(data, e) != 0x6054B50; --e)if (!e || data.length - e > 65558) {
        cbd($0c5e3e04f495ba65$var$err(13, 0, 1), null);
        return tAll;
    }
    var lft = $0c5e3e04f495ba65$var$b2(data, e + 8);
    if (lft) {
        var c = lft;
        var o = $0c5e3e04f495ba65$var$b4(data, e + 16);
        var z = $0c5e3e04f495ba65$var$b4(data, e - 20) == 0x7064B50;
        if (z) {
            var ze = $0c5e3e04f495ba65$var$b4(data, e - 12);
            z = $0c5e3e04f495ba65$var$b4(data, ze) == 0x6064B50;
            if (z) {
                c = lft = $0c5e3e04f495ba65$var$b4(data, ze + 32);
                o = $0c5e3e04f495ba65$var$b4(data, ze + 48);
            }
        }
        var fltr = opts && opts.filter;
        var _loop_3 = function(i) {
            var _a = $0c5e3e04f495ba65$var$zh(data, o, z), c_1 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = $0c5e3e04f495ba65$var$slzh(data, off);
            o = no;
            var cbl = function(e, d) {
                if (e) {
                    tAll();
                    cbd(e, null);
                } else {
                    if (d) files[fn] = d;
                    if (!--lft) cbd(null, files);
                }
            };
            if (!fltr || fltr({
                name: fn,
                size: sc,
                originalSize: su,
                compression: c_1
            })) {
                if (!c_1) cbl(null, $0c5e3e04f495ba65$var$slc(data, b, b + sc));
                else if (c_1 == 8) {
                    var infl = data.subarray(b, b + sc);
                    // Synchronously decompress under 512KB, or barely-compressed data
                    if (su < 524288 || sc > 0.8 * su) try {
                        cbl(null, $0c5e3e04f495ba65$export$90366d8b308ba94a(infl, {
                            out: new $0c5e3e04f495ba65$var$u8(su)
                        }));
                    } catch (e) {
                        cbl(e, null);
                    }
                    else term.push($0c5e3e04f495ba65$export$cae1ce83fe4a1782(infl, {
                        size: su
                    }, cbl));
                } else cbl($0c5e3e04f495ba65$var$err(14, 'unknown compression type ' + c_1, 1), null);
            } else cbl(null, null);
        };
        for(var i = 0; i < c; ++i)_loop_3(i);
    } else cbd(null, {});
    return tAll;
}
function $0c5e3e04f495ba65$export$c757709326bb5901(data, opts) {
    var files = {};
    var e = data.length - 22;
    for(; $0c5e3e04f495ba65$var$b4(data, e) != 0x6054B50; --e)if (!e || data.length - e > 65558) $0c5e3e04f495ba65$var$err(13);
    var c = $0c5e3e04f495ba65$var$b2(data, e + 8);
    if (!c) return {};
    var o = $0c5e3e04f495ba65$var$b4(data, e + 16);
    var z = $0c5e3e04f495ba65$var$b4(data, e - 20) == 0x7064B50;
    if (z) {
        var ze = $0c5e3e04f495ba65$var$b4(data, e - 12);
        z = $0c5e3e04f495ba65$var$b4(data, ze) == 0x6064B50;
        if (z) {
            c = $0c5e3e04f495ba65$var$b4(data, ze + 32);
            o = $0c5e3e04f495ba65$var$b4(data, ze + 48);
        }
    }
    var fltr = opts && opts.filter;
    for(var i = 0; i < c; ++i){
        var _a = $0c5e3e04f495ba65$var$zh(data, o, z), c_2 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = $0c5e3e04f495ba65$var$slzh(data, off);
        o = no;
        if (!fltr || fltr({
            name: fn,
            size: sc,
            originalSize: su,
            compression: c_2
        })) {
            if (!c_2) files[fn] = $0c5e3e04f495ba65$var$slc(data, b, b + sc);
            else if (c_2 == 8) files[fn] = $0c5e3e04f495ba65$export$90366d8b308ba94a(data.subarray(b, b + sc), {
                out: new $0c5e3e04f495ba65$var$u8(su)
            });
            else $0c5e3e04f495ba65$var$err(14, 'unknown compression type ' + c_2);
        }
    }
    return files;
}
module.exports["gzipSync"] = $0c5e3e04f495ba65$export$3d616c3fb3e15483;
module.exports["gunzipSync"] = $0c5e3e04f495ba65$export$c80456f7aaba691c;

});


$parcel$global.rlb("3gMot")
//# sourceMappingURL=CommentEditor.f897b5f4.js.map
